"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[10398,5801],{

/***/ 289924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);



const CustomLink = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].a(({ theme, disabled }) => `
  color: ${disabled ? theme.colors.textSecondary : theme.colors.link500};
  text-decoration: none;
  &:hover {
    color: ${theme.colors.link700};
  }
  ${disabled ? "pointer-events: none;" : ""}
`);
const BreadcrumbItem = ({
  name,
  link,
  disabled = false,
  isEndOfBread = false
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomLink, {
    href: link,
    disabled,
    className: "breadcrumb-item"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    color: isEndOfBread ? "#000" : void 0,
    line: 1,
    level: 1
  }, name));
};
const Label = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 17px;
`;




/***/ }),

/***/ 955006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Breadcrumbs; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BreadcrumbItem_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(289924);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(203494);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ isMobile, theme }) => `
  display: flex;
  padding: ${theme == null ? void 0 : theme.spacing.s16} 0;
  align-items: ${!isMobile ? "flex-end" : "center"};
  column-gap: ${theme == null ? void 0 : theme.spacing.s4};
  white-space: nowrap;
  overflow: hidden;
  ${!isMobile ? `.breadcrumb-item:last-child div {
            white-space: normal
        }` : `
        overflow-x: auto;
        ::-webkit-scrollbar {
          display: none;
        }
      `}
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`);
const Breadcrumbs = (_a) => {
  var _b = _a, {
    breadcrumbs = [],
    isMobile
  } = _b, rest = __objRest(_b, [
    "breadcrumbs",
    "isMobile"
  ]);
  if (!breadcrumbs.length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, rest), {
    isMobile
  }), breadcrumbs.map((item, index) => {
    const isLast = index === breadcrumbs.length - 1 || item.isLast;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      key: index
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BreadcrumbItem_es_js__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbItem */ .g, __spreadValues({
      key: index
    }, item)), !isLast && !!item.name && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RightOutlined */ .g, {
      color: "placeholder",
      size: 16,
      style: { textAlign: "right", overflow: "visible" }
    }));
  }));
};




/***/ }),

/***/ 319326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme }) => [
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F,
  `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
`
]);
const CardHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const CardBody = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const CardFooter = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const Card = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, { children, header, footer, className } = _b, props = __objRest(_b, ["children", "header", "footer", "className"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, __spreadValues({
    className: (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeCls */ .c8)("teko-card", className || ""),
    ref
  }, props), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardHeader, {
    className: "teko-card-header"
  }, header), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardBody, {
    className: "teko-card-body"
  }, children), footer && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardFooter, {
    className: "teko-card-footer"
  }, footer));
});
Card.displayName = "Card";




/***/ }),

/***/ 982226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);
/* harmony import */ var _Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(208984);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${_Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BREAK_POINTS.xl */ .d.xl}) {
    width: ${(props) => props.fluid ? "100%" : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(props.maxWidth || "")};
  }
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    maxWidth,
    fluid,
    ref
  }, others), children);
});
Container.displayName = "Container";




/***/ }),

/***/ 848884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ HomepageFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const HomepageFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.512 1.43055C11.7928 1.18982 12.2073 1.18982 12.4881 1.43055L21.4881 9.14455C21.7264 9.3488 21.8123 9.67984 21.7035 9.9742C21.5946 10.2686 21.3139 10.464 21 10.464H20.75V19.18C20.75 20.1852 19.9665 21 19 21H15V16.1776C15 15.6001 14.7542 15.0462 14.3166 14.6378C13.879 14.2294 13.2856 14 12.6667 14H11.3333C10.7144 14 10.121 14.2294 9.6834 14.6378C9.24583 15.0462 9 15.6001 9 16.1776V21H5C4.0335 21 3.25 20.1852 3.25 19.18V10.464H3.00004C2.68618 10.464 2.40551 10.2686 2.29662 9.9742C2.18773 9.67984 2.27365 9.3488 2.51195 9.14455L11.512 1.43055Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 203494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RightOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RightOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.49976 19.0001L15.4998 12.0001L8.49976 5.00012",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 375640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Layout; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ theme }) => `
  background-color: ${theme == null ? void 0 : theme.colors.background};
  min-height: 100vh;
  padding-bottom: env(safe-area-inset-bottom);
  `, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const WrapperNavBar = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 1050;
`;
const Content = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div``;
const Layout = (_a) => {
  var _b = _a, {
    children,
    navbar,
    bottomContent,
    contentStyles
  } = _b, props = __objRest(_b, [
    "children",
    "navbar",
    "bottomContent",
    "contentStyles"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperNavBar, null, navbar), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, {
    style: contentStyles
  }, children), bottomContent);
};




/***/ }),

/***/ 528938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Anchor = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.a */ .z.a`
  color: unset;
  text-decoration: unset;
`;
const CustomLink = (_a) => {
  var _b = _a, {
    targetPath,
    children,
    targetType = "_self",
    passHref = false
  } = _b, props = __objRest(_b, [
    "targetPath",
    "children",
    "targetType",
    "passHref"
  ]);
  if (!targetPath)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  const a11yProps = {};
  if (typeof children !== "string") {
    a11yProps["aria-label"] = "Image";
  }
  if (targetPath.startsWith("http") || targetPath.startsWith("/"))
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, __spreadValues(__spreadValues({
      target: targetType,
      href: targetPath
    }, a11yProps), props), children);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: passHref ? targetPath : `/search?${targetPath}`,
    prefetch: false,
    legacyBehavior: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, __spreadValues(__spreadValues({
    target: targetType,
    href: passHref ? targetPath : `/search?${targetPath}`
  }, a11yProps), props), children));
};




/***/ }),

/***/ 469100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ListTile; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${props.selected ? "#f5f5f5" : "#fff"};
    padding: 0.6rem;
    cursor: ${props.onClick ? "pointer" : ""};
    &:hover {
      background-color: ${props.type !== "search-suggestion" && "#f5f5f5"};
    }
  `);
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.numberOfLine};
  overflow: hidden;
  margin: 0 0.6rem;
  flex: 1;
`;
const ListTile = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, {
    leading,
    title,
    trailing,
    numberOfLine = 1,
    onClick,
    onMouseEnter,
    type,
    selected = false
  } = _b, props = __objRest(_b, [
    "leading",
    "title",
    "trailing",
    "numberOfLine",
    "onClick",
    "onMouseEnter",
    "type",
    "selected"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({
    ref,
    selected,
    onMouseEnter
  }, props), {
    onClick,
    type
  }), leading, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, {
    numberOfLine
  }, title), trailing);
});
ListTile.displayName = "ListTile";




/***/ }),

/***/ 217622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ SelectOption; }
/* harmony export */ });
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(173698);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46610);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getBorderColor = (props) => {
  var _a;
  return props.isActive && props.theme ? (_a = props.theme) == null ? void 0 : _a.brand.primary : "#e0e0e0";
};
const getColor = (props) => {
  return props.isActive && props.theme ? props.theme.brand.primary : "#333333";
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
  border-radius: 4px;
  display: inline-block;
  user-select: none;
  border: solid 1px ${getBorderColor(props)};
  background-color: ${props.activeBackground && props.isActive ? props.activeBackground : "#fff"};
  padding: 0.5rem 1.25rem;
  position: relative;
  overflow: hidden;
  cursor: ${props.isDisabled ? "default" : "pointer"};
  ${props.block ? "width: 100%;" : ""}

  &:hover {
    background: ${props.isActive || props.isDisabled ? "" : "#f3f3f3"} ;
  }
  `);
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
  color: ${props.activeBackground && props.isActive ? getColor(props) : ""};
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.875rem;
 `);
const ActiveBorder = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => {
  var _a;
  return `
  position: absolute;
  top: -1px;
  right: -1px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: ${props.stickySize === "sm" ? "0px 20px 20px 0px" : "0px 36px 36px 0px"};
  border-color: transparent ${(_a = props.theme) == null ? void 0 : _a.brand.primary} transparent transparent;
`;
});
const Checked = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span((props) => `
  position: absolute;
  top: ${props.stickySize === "sm" ? "-4px" : "0"};
  right: ${props.stickySize === "sm" ? "2px" : "6px"};
  color: #fff;
  z-index: 0;
  font-size: ${props.stickySize === "sm" ? "7px" : "10px"};
`);
const IconWrappper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  margin-left: 8px;
`;
const StyledTag = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Tag */ .V)`
  margin-left: 8px;
`;
const SubTitle = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.p */ .z.p`
  margin-bottom: 0.5rem;
  color: #848788;
`;
const Overlay = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #d8d8d852;
  z-index: 1;
`;
const SelectOption = (_a) => {
  var _b = _a, {
    title,
    subTitle,
    children,
    icon,
    tag,
    isActive,
    onClickOption,
    onClickIcon,
    onMouseEnter,
    activeBackground,
    stickySize,
    isDisabled,
    tags
  } = _b, props = __objRest(_b, [
    "title",
    "subTitle",
    "children",
    "icon",
    "tag",
    "isActive",
    "onClickOption",
    "onClickIcon",
    "onMouseEnter",
    "activeBackground",
    "stickySize",
    "isDisabled",
    "tags"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    activeBackground,
    isActive: !isDisabled && isActive,
    onClick: (ev) => !isDisabled && (onClickOption == null ? void 0 : onClickOption(ev)),
    onMouseEnter,
    isDisabled
  }, props), isDisabled && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Overlay, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, {
    activeBackground,
    isActive: !isDisabled && isActive
  }, title, " ", tag && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, __spreadValues({}, tag)), " ", ((tags == null ? void 0 : tags.length) || 0) > 0 && (tags == null ? void 0 : tags.map((value) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, __spreadValues({
    key: String(value.children)
  }, value)))), icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconWrappper, {
    onClick: onClickIcon
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l, __spreadValues({}, icon)))), subTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SubTitle, null, subTitle), children, !isDisabled && isActive && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActiveBorder, {
    stickySize
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Checked, {
    stickySize
  }, "\u2713")));
};




/***/ }),

/***/ 23212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ OrderBy; },
/* harmony export */   "q": function() { return /* binding */ PromotionType; }
/* harmony export */ });
const PromotionType = {
  PRODUCT: "product",
  COUPON: "coupon"
};
var OrderBy = /* @__PURE__ */ ((OrderBy2) => {
  OrderBy2["ASC"] = "ASC";
  OrderBy2["DESC"] = "DESC";
  return OrderBy2;
})(OrderBy || {});




/***/ }),

/***/ 124902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Description; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(203494);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29921);






const Description = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({ content, maxHeight, showLessLabel, showMoreLabel, className }, ref) => {
  const contentWrapper = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const htmlRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const [expanded, setExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
  const expandContent = (showMore) => {
    var _a, _b;
    const contentElement = htmlRef.current;
    setExpanded(showMore);
    if (showMore) {
      (_a = contentWrapper.current) == null ? void 0 : _a.style.setProperty("max-height", (contentElement == null ? void 0 : contentElement.offsetHeight) + "px");
    } else {
      (_b = contentWrapper.current) == null ? void 0 : _b.style.setProperty("max-height", maxHeight + "px");
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    const contentElement = htmlRef.current;
    if (contentElement) {
      const { offsetHeight } = contentElement;
      if (offsetHeight > maxHeight) {
        expandContent(false);
      }
    }
  }, [htmlRef]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    ref,
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
    padding: "s16"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(ContentWrapper, {
    ref: contentWrapper,
    maxHeight
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(HtmlRenderer, {
    ref: htmlRef,
    dangerouslySetInnerHTML: { __html: content }
  }))), expanded !== void 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(ShowMoreButton, {
    block: true,
    size: "s",
    suffix: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .RightOutlined */ .g, {
      className: "suffix",
      "aria-expanded": expanded
    }),
    onClick: () => expandContent(!expanded)
  }, expanded ? showLessLabel : showMoreLabel));
});
const ContentWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].div`
  overflow: hidden;
  max-height: ${(props) => props.maxHeight}px;
  transition: max-height 0.5s ease-in-out;
`;
const HtmlRenderer = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].div`
  max-width: 100%;
  img {
    max-width: 100%;
  }
`;
const ShowMoreButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z)`
  border: none;
  border-top: 1px solid ${(props) => props.theme.colors.divider};
  border-radius: 0;
  color: ${(props) => props.theme.colors.link500};
  padding: 0.625rem;
  height: unset;

  .button-text {
    font-weight: 400;
  }
  :hover {
    border-top: 1px solid ${(props) => props.theme.colors.divider};
    color: ${(props) => props.theme.colors.link600};
  }
  .suffix {
    /* transition: transform 0.5s ease-in-out; */
    &[aria-expanded='true'] {
      transform: rotate(-90deg);
    }
  }
`;
Description.displayName = "Description";
Description.defaultProps = {
  showMoreLabel: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("Xem th\xEAm"),
  showLessLabel: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("Thu g\u1ECDn"),
  maxHeight: 500
};




/***/ }),

/***/ 29921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Thu gọn": "Collapse",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time",
	"Tìm kiếm gần đây": "Recent search",
	"Chọn khu vực nhận hàng": "Select the location",
	"Vui lòng chọn khu vực nhận hàng của bạn": "Please select your location",
	"Tìm kiếm Tỉnh/ Thành phố": "Search Province/City",
	"Không tìm thấy tỉnh thành phố nào !!": "No provice/city is found !!",
	"Khi thay đổi thông tin đơn hàng thanh toán lại, đơn hiện tại sẽ bị hủy. Giá và khuyến mại đơn hàng có thể bị thay đổi. Bạn có chắc chắn muốn thực hiện thao tác này?": "When changing payment order information, current order will be canceled. Order prices and promotions are subject to change. Are you sure you want to perform this action?",
	"Trường hợp muốn thay đổi hình thức thanh toán hoặc các thông tin khác, vui lòng": "If you want to change your payment configuration or other information, please",
	"Bấm vào đây": "Click here",
	"Xem chi tiết": "View detail",
	"Cần thanh toán": "Need to pay",
	"Giao hàng bởi": "Delivered by",
	"Mã vận đơn": "Shipment code",
	"Cung cấp bởi": "Provided by",
	"Combo giảm ~": "Combo discount ~"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "teko-ecommerce";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), { ns: NAMESPACE }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 650983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(855271);
/* harmony import */ var _SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46610);
/* harmony import */ var _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(349055);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getBackground = (props) => {
  if (props.link)
    return "transparent";
  if (props.outline)
    return props.theme.colors.white;
  return props.disabled ? `${props.theme.colors.gray400} !important` : props.variant === "primary" ? props.theme.brand.primary : props.variant === "secondary" ? props.theme.brand.secondary : props.variant === "tertiary" ? props.theme.brand.tertiary : props.variant === "normal" ? props.theme.colors.gray300 : props.variant === "danger" ? props.theme.colors.red : props.variant === "disabled" ? `${props.theme.colors.gray400} !important` : props.theme.colors.gray200;
};
const getColor = (props) => {
  var _a, _b;
  if (props.variant === "tertiary")
    return props.theme.colors.text;
  if (props.tag && !props.outline && !props.link)
    return props.theme.colors.white + "!important";
  if (props.outline || props.link) {
    return props.variant === "primary" ? (_a = props.theme.brand) == null ? void 0 : _a.primary : props.variant === "secondary" ? (_b = props.theme.brand) == null ? void 0 : _b.secondary : props.variant === "danger" ? props.theme.colors.red : props.variant === "disabled" ? `${props.theme.colors.gray600} !important` : props.theme.colors.text;
  }
  if (props.disabled)
    return `${_configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.gray600 */ .r.colors.gray600} !important`;
  return props.variant && props.variant !== "normal" && !props.link ? _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.white */ .r.colors.white : _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.gray900 */ .r.colors.gray900;
};
const StyledButton = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button */ .Z.button((props) => {
  return `
    cursor: pointer;
    border-radius: 4px;
    overflow: hidden;
    ${props.size === "lg" ? `
        line-height: 1.5;
        padding: .5rem 1rem;` : `
        line-height: 1rem;
        padding: .365rem .75rem;`}
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: ${getBackground(props)};
    border-color: ${props.outline ? getColor(props) : getBackground(props)};
    color: ${getColor(props)};
    border-width: 1px;
    border-style: solid;
    user-select: none;
    text-decoration: none;
    flex-direction: ${props.flexDirection};
    position: relative;
    ${props.block ? `width: 100%;` : ""}
    ${props.disabled && "pointer-events: none;"}
    &:focus {
      outline: 0;
    }
    `;
}, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const Spacer = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div`
  width: 0.4rem;
  height: 0.4rem;
`;
const LoadingWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div((props) => `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${getBackground(props)};
  .pulse {
    position: relative;
  left: -9999px;
  width: 4px;
  height: 4px;
  border-radius: 5px;
  background-color: ${getColor(props)};
  color: ${getColor(props)};
  box-shadow: 9999px 0 0 -5px ${getColor(props)};
  animation: dot-pulse 1.5s infinite linear;
  animation-delay: 0.25s;

  &:before,
  &:after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${getColor(props)};
    color: ${getColor(props)};
  }
  &:before {
    box-shadow: 9988px 0 0 -5px ${getColor(props)};
    animation: dot-pulse-before 1.5s infinite linear;
    animation-delay: 0s;
  }
  &:after {
    box-shadow: 10010px 0 0 -5px ${getColor(props)};
    animation: dot-pulse-after 1.5s infinite linear;
    animation-delay: 0.5s;
  }
  @keyframes dot-pulse-before {
    0% {
      box-shadow: 9988px 0 0 -5px ${getColor(props)};
    }
    30% {
      box-shadow: 9988px 0 0 2px ${getColor(props)};
    }
    60%,
    100% {
      box-shadow: 9988px 0 0 -5px ${getColor(props)};
    }
  }

  @keyframes dot-pulse {
    0% {
      box-shadow: 9999px 0 0 -5px ${getColor(props)};
    }
    30% {
      box-shadow: 9999px 0 0 2px ${getColor(props)};
    }
    60%,
    100% {
      box-shadow: 9999px 0 0 -5px ${getColor(props)};
    }
  }

  @keyframes dot-pulse-after {
    0% {
      box-shadow: 10010px 0 0 -5px ${getColor(props)};
    }
    30% {
      box-shadow: 10010px 0 0 2px ${getColor(props)};
    }
    60%,
    100% {
      box-shadow: 10010px 0 0 -5px ${getColor(props)};
    }
  }
  }
`);
const StyledLink = StyledButton.withComponent("a");
const Button = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, {
    outline,
    variant,
    children,
    block,
    tag,
    icon,
    disabled,
    flexDirection = "row",
    loading,
    onClick
  } = _a, others = __objRest(_a, [
    "outline",
    "variant",
    "children",
    "block",
    "tag",
    "icon",
    "disabled",
    "flexDirection",
    "loading",
    "onClick"
  ]);
  const ButtonTag = tag === "a" ? StyledLink : StyledButton;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonTag, __spreadValues({
    ref,
    block,
    variant,
    outline,
    flexDirection,
    disabled,
    tag,
    onClick: loading ? void 0 : onClick
  }, others), icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, __spreadValues({}, icon)), icon && children && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Spacer, {
    className: "spacer"
  }), children, loading && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadingWrapper, {
    variant,
    outline
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "pulse"
  })));
});
Button.displayName = "Button";




/***/ }),

/***/ 865237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Col; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCol = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ col }) => {
  if (!col) {
    return {
      flex: "1 0 0%",
      minWidth: 0
    };
  }
  return {
    flex: "0 0 auto",
    width: `${col / 12 * 100}%`,
    paddingRight: "0.5rem",
    paddingLeft: "0.5rem"
  };
}, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const Col = (_a) => {
  var _b = _a, {
    children,
    col
  } = _b, props = __objRest(_b, [
    "children",
    "col"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, __spreadValues({
    col
  }, props), children);
};




/***/ }),

/***/ 358277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Container = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(styled_system__WEBPACK_IMPORTED_MODULE_0__.space, ({ fluid }) => {
  const styles = {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: "1rem",
    paddingRight: "1rem"
  };
  if (!fluid) {
    styles.maxWidth = "1264px";
  }
  return styles;
});




/***/ }),

/***/ 64201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(456933);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(987900);





const Anchor = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a */ .Z.a`
  color: unset;
  text-decoration: unset;
`;
const CustomLink = ({
  targetPath,
  children,
  targetType = "_self"
}) => {
  const [href, setHref] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    pathname: targetPath,
    query: {}
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const init = async () => {
      if (!targetPath)
        return;
      const { pathname, query } = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUrlObject */ .Bi)(targetPath));
      setHref({
        pathname: pathname || targetPath,
        query
      });
    };
    init();
  }, [targetPath]);
  if (!targetPath)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  if (targetPath.startsWith("http"))
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, {
      target: targetType,
      href: targetPath
    }, children);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href,
    as: targetPath,
    passHref: true,
    legacyBehavior: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, {
    target: targetType
  }, children));
};




/***/ }),

/***/ 589561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const StyledInput = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input */ .Z.input`
  display: block;
  width: 100%;
  border-radius: 4px;
  padding: 0.375rem 0.75rem;
  border: 1px solid #e0e0e0;
  min-height: 16px;
  &:focus {
    outline: 0;
  }
  /* Chrome, Safari, Edge, Opera */
  &:-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
const Input = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadValues({}, props));




/***/ }),

/***/ 179185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; },
/* harmony export */   "x": function() { return /* binding */ WebpImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => ({
  maxWidth: "100%",
  position: "relative",
  overflow: "hidden",
  flex: "1 0 auto",
  display: "flex",
  cursor: props.onClick ? "pointer" : "unset",
  zIndex: 0,
  margin: "auto",
  borderRadius: props.borderRadius + "px",
  paddingBottom: props.height ? "" : `${100 / props.aspectRatio}%`,
  border: props.border ? "1px solid #e0e0e0" : "",
  height: props.height ? `${props.height}px !important` : "",
  width: props.width ? `${props.width}px` : "100%",
  backgroundImage: props.thumbnail ? `url("${props.thumbnail}")` : null,
  backgroundSize: props.thumbnail ? "cover" : null,
  contentVisibility: props.height && props.width ? "auto" : null
}));
const WebpImage = ({
  src,
  onClick,
  className,
  height,
  width,
  imageWidth,
  alt = "",
  decoding = "async",
  onLoad
}) => {
  const placeHolder = "data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
  let imageUrl = src ? src : placeHolder;
  let altImageUrl = null;
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    if (imageWidth || width) {
      imageUrl = `${imageUrl}=w${imageWidth || width}`;
    }
    const checkExt = /=[a-z0-9-]+$/;
    altImageUrl = imageUrl;
    imageUrl = `${imageUrl}${checkExt.test(imageUrl) ? "-rw" : "=rw"}`;
  }
  const imgError = (event) => {
    if (event.target.src !== placeHolder) {
      event.target.src = placeHolder;
    }
    return;
  };
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width,
    height,
    onClick,
    className,
    alt,
    onError: imgError,
    src: imageUrl,
    loading: "lazy",
    decoding,
    onLoad
  });
  return altImageUrl ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: imageUrl,
    type: "image/webp"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: altImageUrl,
    type: "image/png"
  }), imgEle) : imgEle;
};
const WrapperImage = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WebpImage)((props) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${props.contain ? "contain" : props.cover ? "cover" : ""};
  transition: transform 0.5s;
  &:hover {
    transform: ${props.hover === "zoom" ? "scale(1.05)" : ""};
  }
  `);
const LazyImage = ({
  src,
  onClick,
  className,
  contain = false,
  cover = false,
  aspectRatio = 1,
  height,
  width,
  alt = "",
  border = false,
  hover = "",
  borderRadius = 0,
  thumbnail,
  decoding = "async",
  imageWidth
}) => {
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperImage, {
    hover,
    className: "lazyload",
    contain,
    imageWidth,
    cover,
    alt,
    "data-src": src,
    src,
    decoding
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height,
    width,
    border,
    aspectRatio,
    borderRadius,
    onClick,
    className,
    thumbnail
  }, imgEle);
};




/***/ }),

/***/ 995667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Row; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledRow = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ noGutters }) => `
  display: flex;
  flex-wrap: wrap;
  ${noGutters ? "" : `
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  `}
`, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const Row = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRow, __spreadValues({}, props), children);
};




/***/ }),

/***/ 173698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getBackground = (props) => {
  const { variant, theme } = props;
  return variant && (theme.brand[variant] || theme.colors[variant]) || variant || theme.colors.dark;
};
const StyledTag = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  background-color: ${props.outline ? "#fff" : getBackground(props)};
  color: ${props.outline ? getBackground(props) : props.theme.colors.white};
  border: ${props.outline ? `1px solid ${getBackground(props)}` : ""} ;
  display: inline;
  padding: 2px 8px;
  border-radius: 2px;
  font-size: 10px;
  line-height: 12px;
  font-weight: 500;
  align-self: center;
  `);
const Tag = (_a) => {
  var _b = _a, {
    variant,
    outline = false,
    children,
    className
  } = _b, props = __objRest(_b, [
    "variant",
    "outline",
    "children",
    "className"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, __spreadValues({
    className,
    outline,
    variant
  }, props), children);
};




/***/ }),

/***/ 708966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ButtonChevron; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46610);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(650983);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getTransform = (props) => {
  let style = "";
  switch (props.direction) {
    case "right":
      style = "transform: rotate(90deg)";
      break;
    case "down":
      style = "transform: rotate(180deg)";
      break;
    case "left":
      style = "transform: rotate(-90deg)";
      break;
  }
  return style;
};
const StyledIcon = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l)((props) => `
  transition: transform .2s ease-in-out;
  ${getTransform(props)};
  position: relative;
  margin-left: 2px;
`);
const StyledButton = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z)`
  display: flex;
`;
const Text = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
`;
const ButtonChevron = (_a) => {
  var _b = _a, {
    children,
    direction,
    showArrow = true
  } = _b, props = __objRest(_b, [
    "children",
    "direction",
    "showArrow"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, children), showArrow && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    direction,
    name: "chevron-up",
    size: 12
  }));
};




/***/ }),

/***/ 797864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ theme, withPadding }) => `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
  ${withPadding ? "padding: .5rem;" : ""}
`, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const CardHeader = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div``;
const CardBody = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div``;
const CardFooter = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div``;
const Card = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, { children, header, footer, withPadding } = _b, props = __objRest(_b, ["children", "header", "footer", "withPadding"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, __spreadValues({
    ref,
    withPadding
  }, props), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardHeader, {
    className: "card-header"
  }, header), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardBody, {
    className: "card-body"
  }, children), footer && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardFooter, {
    className: "card-footer"
  }, footer));
});
Card.displayName = "Card";




/***/ }),

/***/ 526439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Currency; },
/* harmony export */   "t": function() { return /* binding */ thoundsandDelimiter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75537);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function thoundsandDelimiter(number) {
  if (!number) {
    return "0";
  }
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
const StyledCurrency = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  width: max-content;
  display: inline-block;
`;
const Text = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span(({ underline }) => _emotion_react__WEBPACK_IMPORTED_MODULE_2__.css`
    text-decoration: ${underline ? "underline" : ""};
  `);
const Currency = (_a) => {
  var _b = _a, {
    value,
    hideCurrency = false,
    space = false,
    underline = false,
    formattedValue
  } = _b, props = __objRest(_b, [
    "value",
    "hideCurrency",
    "space",
    "underline",
    "formattedValue"
  ]);
  if (!value && value !== 0) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), "\xA0");
  }
  if (!!formattedValue) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), formattedValue, !hideCurrency && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, space && " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, {
      underline
    }, "\u0111")));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), thoundsandDelimiter(value), !hideCurrency && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, space && " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, {
    underline
  }, "\u0111")));
};




/***/ }),

/***/ 665207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ HeadSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(504133);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const HeadSection = (param)=>{
    let { title , metaTitle , description , keywords , image , canonical , prevHref , nextHref , noindex =false , links , schemaPage  } = param;
    const { meta  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const schemaPageJson = typeof schemaPage === "string" ? (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getJson */ .LK)(schemaPage) : schemaPage;
    const schemas = Array.isArray(schemaPageJson) ? schemaPageJson : schemaPageJson && [
        schemaPageJson
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle || title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle || title || meta.title
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description || meta.description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description || meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image || meta.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image || meta.image
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            prevHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevHref
            }),
            nextHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextHref
            }),
            links === null || links === void 0 ? void 0 : links.map((attrs)=>Object.keys(attrs).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, attrs))),
            meta.dcmaVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "dmca-site-verification",
                content: meta.dcmaVerificationContent
            }),
            meta.fbDomainVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: meta.fbDomainVerificationContent
            }),
            !!(schemas === null || schemas === void 0 ? void 0 : schemas.length) && schemas.map((schema, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schema)
                    }
                }, index))
        ]
    });
};


/***/ }),

/***/ 303094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ MobileLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(375640);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(420577);
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68706);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  .header-filter {\n    top: ",
        ";\n    border-bottom: 1px solid ",
        ";\n  }\n  .sort-bottom-sheet {\n    top: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






const MobileLayout = (_param)=>{
    var { navbar , children , expandedNavBar  } = _param, props = _objectWithoutProperties(_param, [
        "navbar",
        "children",
        "expandedNavBar"
    ]);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { query  } = router;
    const { 0: isSupportOmniApp , 1: setSupportOmniApp  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const hideHeader = !!query.hideHeader || !!query.supportOmniAppUI;
    /** setSupportOmniApp */ (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        try {
            (async ()=>{
                const res = await _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__/* ["default"].erp */ .Z.erp().isSupportOmniApp(); // support in case redirect from landing page to landing page
                setSupportOmniApp(res);
            })();
        } catch (err) {
            (0,_teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger */ .k)(err);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLayout, _objectSpreadProps(_objectSpread({
        hideHeader: isSupportOmniApp || hideHeader,
        navbar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
            children: [
                hideHeader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HiddenNavBar, {
                    children: navbar
                }) : navbar,
                expandedNavBar
            ]
        })
    }, props), {
        children: children
    }));
};
const HiddenNavBar = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject());
const StyledLayout = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Layout */ .A)(_templateObject1(), (param)=>{
    let { showBreadcrumb , showTitle , hideHeader  } = param;
    return "".concat(56 + // UX4BUYER-5506: Display Breadcrumbs for colelction page
    (showBreadcrumb ? 36 : 0) + // UX4BUYER-5504: add page title and quantity
    (showTitle ? 32 : 0) - // UX4BUYER-5790: hidden header
    (hideHeader ? 56 : 0), "px");
}, (param)=>{
    let { theme  } = param;
    return theme.colors.background;
}, (param)=>{
    let { showBreadcrumb , showTitle , hideHeader  } = param;
    return "".concat(96 + (showBreadcrumb ? 36 : 0) + (showTitle ? 32 : 0) - (hideHeader ? 56 : 0), "px");
});


/***/ }),

/***/ 235904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; },
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80912);




const Loading = (param)=>{
    let { isLoading , children  } = param;
    var ref;
    const { logo  } = (0,_contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
        isLoading: isLoading,
        logo: (ref = (logo === null || logo === void 0 ? void 0 : logo.loading) || (logo === null || logo === void 0 ? void 0 : logo.lite)) === null || ref === void 0 ? void 0 : ref.path,
        children: children
    });
};
const PreLoad = (param)=>{
    let { isLoading , height  } = param;
    var ref;
    const { logo  } = (0,_contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
        isLoading: isLoading,
        style: {
            height: typeof height === "number" ? "".concat(height, "px") : height
        },
        logo: (ref = (logo === null || logo === void 0 ? void 0 : logo.loading) || (logo === null || logo === void 0 ? void 0 : logo.lite)) === null || ref === void 0 ? void 0 : ref.path
    });
};


/***/ }),

/***/ 481689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ BuildPcMobileItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(319326);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(670894);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(650983);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(770024);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(811850);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(73586);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(260613);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  color: unset;\n  text-decoration: unset;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 1rem;\n  transition: box-shadow 0.2s ease-in-out;\n  &:hover {\n    box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.08);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  min-height: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  font-weight: 500;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 5px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  color: #757575;\n  font-size: 0.8125rem;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  height: 32px;\n  width: 60px;\n  padding: 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






const Anchor = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].a(_templateObject());
const StyledCard = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Card */ .Z)(_templateObject1());
const StyledPrice = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .ProductPrice */ .j)(_templateObject2());
const Title = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject3());
const StyledProductGifts = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .ProductGifts */ .W)(_templateObject4());
const SKU = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].span(_templateObject5());
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z)(_templateObject6());
const StyledButtonDelete = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT)((param)=>{
    let { theme  } = param;
    return "\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.link500, ";\n");
});
const BuildPcMobileItem = (_param)=>{
    var { title , product , onIncrease , onDecrease , onClick , actionText , quantity , setQuantity , showDeleteButton , onDelete  } = _param, props = _objectWithoutProperties(_param, [
        "title",
        "product",
        "onIncrease",
        "onDecrease",
        "onClick",
        "actionText",
        "quantity",
        "setQuantity",
        "showDeleteButton",
        "onDelete"
    ]);
    var ref, ref1;
    const disableButton = ()=>{
        var ref;
        if (product && !(product === null || product === void 0 ? void 0 : (ref = product.price) === null || ref === void 0 ? void 0 : ref.latestPrice)) return true;
    };
    const selectHardwareButton = product && product.showContact ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
        block: true,
        variant: "primary",
        tag: "a",
        href: "https://m.me/phongvuvietnam",
        target: "_blank",
        children: (0,_i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Li\xean hệ")
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
        disabled: disableButton(),
        onClick: onClick,
        variant: "primary",
        children: actionText
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledCard, _objectSpreadProps(_objectSpread({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                align: "middle",
                children: title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                            span: 4,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                justify: "start",
                                marginBottom: product ? "s16" : undefined,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                    children: title
                                })
                            })
                        }),
                        !product && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                            span: 8,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                justify: "end",
                                children: selectHardwareButton
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                children: product && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                    span: 12,
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: 10
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .LazyImage */ .w, {
                                width: 65,
                                height: 65,
                                src: product === null || product === void 0 ? void 0 : product.imageUrl,
                                onClick: ()=>{
                                    if (!product) onClick === null || onClick === void 0 ? void 0 : onClick();
                                },
                                border: true,
                                borderRadius: 8,
                                contain: true
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                            style: {
                                flex: 1
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                                span: 12,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anchor, {
                                        // @ts-ignore
                                        href: (ref = product.link) === null || ref === void 0 ? void 0 : (ref1 = ref.as) === null || ref1 === void 0 ? void 0 : ref1.pathname,
                                        rel: "noreferrer noopener",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_12__/* .ProductName */ .r, {
                                            name: product.name || (0,_i18n__WEBPACK_IMPORTED_MODULE_8__.t)("T\xean sản phẩm đang được cập nhật")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                        marginTop: "s4",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SKU, {
                                            children: [
                                                "SKU: ",
                                                product.sku
                                            ]
                                        })
                                    }),
                                    product.gifts && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledProductGifts, {
                                            label: (0,_i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Tặng ngay"),
                                            images: product.gifts.images
                                        })
                                    }),
                                    product.price && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                        marginTop: "s8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledPrice, {
                                            price: product.price.latestPrice,
                                            discount: product.price.discountPercent,
                                            listedPrice: product.price.supplierRetailPrice
                                        })
                                    }),
                                    quantity && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                        marginTop: "s8",
                                        align: "middle",
                                        justify: "start",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_13__/* .BuildPcNumberStepper */ .F, {
                                                        onIncrease: onIncrease,
                                                        onDecrease: onDecrease,
                                                        setValue: setQuantity,
                                                        value: quantity
                                                    })
                                                }),
                                                showDeleteButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                                    justify: "center",
                                                    align: "middle",
                                                    marginTop: "s12",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButtonDelete, {
                                                        level: 1,
                                                        onClick: onDelete,
                                                        children: (0,_i18n__WEBPACK_IMPORTED_MODULE_8__.t)("X\xf3a")
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                            justify: "start",
                            children: selectHardwareButton
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 704251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(802705);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Shape */ .b)((param)=>{
    let { direction  } = param;
    return "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-column-gap: 0.5rem;\n  a {\n    text-decoration: unset;\n  }\n  direction: ".concat(direction, ";\n");
});
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z)((param)=>{
    let { isActive  } = param;
    return "\n    ".concat(!isActive ? "background-color: #E0E0E0" : "", ";\n    direction: ltr;\n  ");
});
const BuildPcMobileTabs = (_param)=>{
    var { onClickTab , onResetConfig , lsActiveTab  } = _param, props = _objectWithoutProperties(_param, [
        "onClickTab",
        "onResetConfig",
        "lsActiveTab"
    ]);
    const { 0: activeTab , 1: setActiveTab  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(lsActiveTab || 0);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, _objectSpreadProps(_objectSpread({
                marginBottom: "s8"
            }, props), {
                children: [
                    0,
                    1,
                    2
                ].map((tab)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                        variant: tab === activeTab ? "primary" : "default",
                        isActive: tab === activeTab,
                        onClick: ()=>{
                            setActiveTab(tab);
                            onClickTab && onClickTab(tab);
                        },
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Cấu h\xecnh {{number}}", {
                            number: tab + 1
                        })
                    }, tab))
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
                direction: "rtl",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledButton, {
                    isActive: true,
                    variant: "primary",
                    onClick: onResetConfig,
                    children: [
                        (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Tạo lại"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .RefreshOutlined */ .y, {
                            color: "white",
                            size: 16,
                            style: {
                                marginLeft: "0.5rem"
                            }
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BuildPcMobileTabs);


/***/ }),

/***/ 316555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ BuildPc; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Container/Container.es.js
var Container_es = __webpack_require__(358277);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcItem/BuildPcItem.es.js
var BuildPcItem_es = __webpack_require__(123579);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/MiniSlides/MiniSlides.es.js
var MiniSlides_es = __webpack_require__(804393);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcTabs/BuildPcTabs.es.js
var BuildPcTabs_es = __webpack_require__(562194);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcSummary/BuildPcSummary.es.js + 1 modules
var BuildPcSummary_es = __webpack_require__(924780);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(528938);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/PrintBuildPc/PrintBuildPc.es.js
var PrintBuildPc_es = __webpack_require__(327601);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Description/Description.es.js
var Description_es = __webpack_require__(124902);
// EXTERNAL MODULE: ./components/Loading.tsx
var Loading = __webpack_require__(235904);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(534090);
// EXTERNAL MODULE: ./contexts/BuildPcContext.tsx
var BuildPcContext = __webpack_require__(677111);
;// CONCATENATED MODULE: ./repositories/category.ts
const CategoryRepository = {
    all () {
        return [
            {
                name: "Vi xử l\xfd",
                id: "553",
                icon: "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/cpu.svg?alt=media&token=77cbc8d7-f570-45a4-8bee-8d87265e39fd"
            },
            {
                name: "Bo mạch chủ",
                id: "552",
                icon: "http://static.360buyimg.com/master-of-loader/pc/img/mother-board-icon.82595f5e.svg"
            },
            {
                name: "RAM",
                id: "548",
                icon: "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/ram.svg?alt=media&token=2ed78d9a-5622-4be9-9ef7-e7c53e3ac544"
            },
            {
                name: "Ổ HDD",
                id: "1861",
                icon: "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/hdd.svg?alt=media&token=05efe4a2-d30e-4f2f-8493-f61eea388840"
            },
            {
                name: "Ổ SSD",
                id: "637",
                icon: "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/ssd.svg?alt=media&token=e4be0398-ae2a-4735-b2aa-240c46039abe"
            },
            {
                name: "VGA",
                id: "554",
                icon: "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/vga-card.svg?alt=media&token=9f112617-13ac-4016-aa3b-6f03d53a9f9a"
            },
            {
                name: "Nguồn",
                id: "541",
                icon: "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/power-supply.svg?alt=media&token=47f2d1e9-6927-4778-917d-cb52e7d0b027"
            },
            {
                name: "Vỏ case",
                id: "549",
                icon: "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/server.svg?alt=media&token=66b99bc2-7d47-4dd7-a1bb-b22976b54b41"
            },
            {
                name: "Tản nhiệt",
                id: "555",
                icon: "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/fan.svg?alt=media&token=726a4f32-3cb8-4bff-ad7b-0428414f1443"
            },
            {
                name: "M\xe0n h\xecnh",
                id: "540",
                icon: "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/monitor.svg?alt=media&token=9382ecd3-da49-4542-a9b5-8d8eb0a07128"
            },
            {
                name: "B\xe0n ph\xedm",
                id: "543",
                icon: "http://static.360buyimg.com/master-of-loader/pc/img/keyboard-icon.87b45d1c.svg"
            },
            {
                name: "Chuột",
                id: "542",
                icon: "http://static.360buyimg.com/master-of-loader/pc/img/mouse-icon.144f4d99.svg"
            },
            {
                name: "Tai nghe",
                id: "972",
                icon: "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/headphones.svg?alt=media&token=ca5310b8-dc9f-4c2e-9b51-54c07fb4327c"
            },
            {
                name: "Loa m\xe1y t\xednh",
                id: "905",
                icon: "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/windows-media-audio.svg?alt=media&token=7d43a7d7-6834-4ecf-99eb-5edfce667300"
            }, 
        ];
    },
    allById () {
        const categoryDict = {};
        this.all().forEach((category)=>{
            categoryDict[category.id] = category.name;
        });
        return categoryDict;
    }
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Pagination/Pagination.es.js
var Pagination_es = __webpack_require__(85468);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Card/Card.es.js
var Card_es = __webpack_require__(797864);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcModal/BuildPcModalHeader.es.js
var BuildPcModalHeader_es = __webpack_require__(14956);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcModal/BuildPcModalContent.es.js
var BuildPcModalContent_es = __webpack_require__(433329);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var index_es = __webpack_require__(775002);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/HelperContext.tsx
var HelperContext = __webpack_require__(329706);
// EXTERNAL MODULE: ./contexts/FrameContext.tsx
var FrameContext = __webpack_require__(927890);
// EXTERNAL MODULE: ./hooks/useHandlerUnderEighteenYearOld.ts + 2 modules
var useHandlerUnderEighteenYearOld = __webpack_require__(725530);
;// CONCATENATED MODULE: ./hooks/useConvertProductCard.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const useNewProductCard = function() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { isAllowATCFromListing , contactLink , showNewProductGift  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { productHelper  } = (0,HelperContext/* useHelper */.H)();
    const { frames  } = (0,FrameContext/* useFrame */.x)();
    const cartV2 = (0,CartContextV2/* useCartV2 */.T6)();
    const { uomCodeToDisplayDecimalQuantity , isDisplayUom  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { convertProduct  } = (0,useHandlerUnderEighteenYearOld/* useHandlerUnderEighteenYearOld */.x)();
    const { disableHandlerUnder18  } = props;
    const convertNewProductCard = (0,react.useCallback)((el)=>{
        const product = _objectSpreadProps(_objectSpread({}, productHelper.convertNewProductCard(el, {
            cartV2,
            frames,
            showUom: isDisplayUom,
            contactLink,
            showCtaButton: isAllowATCFromListing,
            showNewProductGift
        })), {
            precisionToDisplayDecimalQuantity: uomCodeToDisplayDecimalQuantity === el.productInfo.uomCode ? 3 : 0
        });
        if (!disableHandlerUnder18) {
            // Implement under 18 flow, follow ECOM-315 for view detail
            const { imageUrl , addToCart  } = convertProduct(product);
            product.imageUrl = imageUrl;
            product.addToCart = addToCart;
        }
        return product;
    }, [
        cartV2,
        frames
    ]);
    return {
        convertNewProductCard
    };
};

// EXTERNAL MODULE: ./hooks/useMenuItems.tsx
var useMenuItems = __webpack_require__(702070);
// EXTERNAL MODULE: ./hooks/useDiscovery.tsx + 1 modules
var useDiscovery = __webpack_require__(88837);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Divider/Divider.es.js
var Divider_es = __webpack_require__(912841);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/NoProductsFound/NoProductsFound.es.js
var NoProductsFound_es = __webpack_require__(980424);
// EXTERNAL MODULE: ./containers/BuildPc/BuildPcMobileItem.tsx
var BuildPcMobileItem = __webpack_require__(481689);
;// CONCATENATED MODULE: ./components/BuildPcModal/BuildPcMobileModalContent.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  border-radius: unset;\n  padding: 0.625rem 0.5rem 0.625rem 0;\n  &:hover {\n    box-shadow: unset;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  overflow-y: scroll;\n  overflow-x: hidden;\n  border-bottom: 1px dashed #ddd;\n  border-top: 1px dashed #ddd;\n  ::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n  }\n\n  ::-webkit-scrollbar {\n    width: 4px;\n    background-color: #f5f5f5;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: #999;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 95%;\n  margin: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 5rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








const StyledBuildPcItem = (0,emotion_styled_browser_esm["default"])(BuildPcMobileItem/* BuildPcMobileItem */.g)(_templateObject());
const Wrapper = emotion_styled_browser_esm["default"].div(_templateObject1());
const StyledDivider = (0,emotion_styled_browser_esm["default"])(Divider_es/* Divider */.i)(_templateObject2());
const StyledNoProductsFound = (0,emotion_styled_browser_esm["default"])(NoProductsFound_es/* NoProductsFound */.H)(_templateObject3());
const BuildPcMobileModalContent = (param)=>{
    let { products =[] , isLoading , onClick  } = param;
    return isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {
        top: 150,
        isLoading: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {})
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNoProductsFound, {
                show: !isLoading && !products.length
            }),
            products.map((product, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBuildPcItem, {
                            onClick: ()=>onClick(product.sku),
                            product: product,
                            actionText: (0,i18n.t)("Chọn")
                        }, product.sku),
                        index < products.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {})
                    ]
                }, product.sku))
        ]
    });
};

;// CONCATENATED MODULE: ./components/BuildPcModal/BuildPcModal.tsx
function BuildPcModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BuildPcModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BuildPcModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BuildPcModal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function BuildPcModal_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        BuildPcModal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function BuildPcModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function BuildPcModal_templateObject() {
    const data = BuildPcModal_taggedTemplateLiteral([
        "\n  padding: 0.5rem 0;\n  display: flex;\n  justify-content: center;\n  height: 62px;\n"
    ]);
    BuildPcModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BuildPcModal_templateObject1() {
    const data = BuildPcModal_taggedTemplateLiteral([
        "\n  ul {\n    padding: 0;\n  }\n"
    ]);
    BuildPcModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BuildPcModal_templateObject2() {
    const data = BuildPcModal_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    BuildPcModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








const PaginationWrapper = styled_es/* styled.div */.z.div(BuildPcModal_templateObject());
const StyledPagination = (0,styled_es/* styled */.z)(Pagination_es/* Pagination */.t)(BuildPcModal_templateObject1());
const CardMobile = styled_es/* styled.div */.z.div(BuildPcModal_templateObject2());
const BuildPcModal = (param)=>{
    let { onHide , category , initialSocketOption  } = param;
    var ref;
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { convertNewProductCard  } = useNewProductCard({
        disableHandlerUnder18: true
    });
    const { result: menuItem  } = (0,useMenuItems/* useMenuItemById */.p6)(category.id);
    const configs = (menuItem === null || menuItem === void 0 ? void 0 : menuItem.configs) || {};
    const defaultSearchParams = {
        limit: 16,
        page: 1,
        returnAllVariants: true
    };
    // TODO: check type searchParams in @teko/utils to change type any here
    const { 0: searchParams , 1: setSearchParams  } = (0,react.useState)(BuildPcModal_objectSpread({}, defaultSearchParams, configs));
    const filterParams = BuildPcModal_objectSpread({}, configs, {
        returnFilterable: [
            "FILTER_TYPE_BRAND",
            "FILTER_TYPE_PRICE",
            "FILTER_TYPE_ATTRIBUTE", 
        ]
    });
    const dispatch = (0,BuildPcContext/* useBuildPcDispatch */.bC)();
    const { result , isLoading  } = (0,useDiscovery/* useDiscoverySearch */.b9)(!!Object.keys(configs).length ? BuildPcModal_objectSpread({}, configs, searchParams) : {});
    const { result: filterData  } = (0,useDiscovery/* useDiscoverySearch */.b9)(!!Object.keys(configs).length ? filterParams : {});
    const products = result.products;
    const filters = filterData === null || filterData === void 0 ? void 0 : (ref = filterData.cookedFilters) === null || ref === void 0 ? void 0 : ref.slice(0, 6);
    const onSelectProduct = (sku)=>{
        if (!products.length) return;
        const product = products.find((product)=>product.productInfo.sku === sku);
        if (!product) return;
        dispatch({
            type: "ADD_HARDWARE",
            payload: {
                categoryId: category.id,
                product: convertNewProductCard(product)
            }
        });
    };
    const onUpdateParams = (code, value)=>{
        let params = searchParams;
        if (code !== "keyword" && params[code]) {
            var ref;
            const filterCodeValues = ((ref = params[code]) === null || ref === void 0 ? void 0 : ref.toString().split(",")) || [];
            const index = filterCodeValues.indexOf(value);
            if (index !== -1) {
                filterCodeValues.splice(index, 1);
            } else {
                filterCodeValues.push(value);
            }
            if (filterCodeValues.length) {
                params[code] = filterCodeValues;
            } else {
                const { [code]: tbr  } = params, restFilterParams = _objectWithoutProperties(params, [
                    code
                ].map(_toPropertyKey));
                params = restFilterParams;
            }
        } else {
            params[code] = value;
        }
        setSearchParams((0,index_es.cleanObject)(params));
    };
    const onSort = (0,react.useCallback)((sort, order)=>{
        let params = searchParams;
        if (sort === searchParams.sort && order === searchParams.order) {
            const { sort: tbr , order: tbr2  } = params, restFilterParams = _objectWithoutProperties(params, [
                "sort",
                "order"
            ]);
            params = BuildPcModal_objectSpreadProps(BuildPcModal_objectSpread({}, restFilterParams), {
                page: 1
            });
        } else {
            params = BuildPcModal_objectSpreadProps(BuildPcModal_objectSpread({}, searchParams), {
                sort: sort,
                order: order,
                page: 1
            });
        }
        setSearchParams((0,index_es.cleanObject)(params));
    }, [
        searchParams
    ]);
    const getActivatedFilters = (filters, searchParams)=>{
        if (!filters || !filters.length) return [];
        const activatedFilters = [];
        Object.keys(searchParams).forEach((queryItem)=>{
            filters.forEach((filter)=>{
                if (filter.code === queryItem) {
                    filter.options.forEach((value)=>{
                        var ref;
                        if (!!value.optionCode && ((ref = searchParams[queryItem]) === null || ref === void 0 ? void 0 : ref.includes(value.optionCode))) {
                            activatedFilters.push(value);
                        }
                    });
                }
            });
        });
        return activatedFilters;
    };
    const activeValues = (0,react.useMemo)(()=>getActivatedFilters(filters || [], searchParams), [
        filters,
        searchParams
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        const socketOption = (ref = filters === null || filters === void 0 ? void 0 : filters.find((f)=>{
            return f.code === (initialSocketOption === null || initialSocketOption === void 0 ? void 0 : initialSocketOption.filterCode) && f.name === (initialSocketOption === null || initialSocketOption === void 0 ? void 0 : initialSocketOption.filterName);
        })) === null || ref === void 0 ? void 0 : ref.options.find((opt)=>{
            return opt.optionName === (initialSocketOption === null || initialSocketOption === void 0 ? void 0 : initialSocketOption.optionName);
        });
        const socketSearchParam = {
            [socketOption === null || socketOption === void 0 ? void 0 : socketOption.filterCode]: socketOption === null || socketOption === void 0 ? void 0 : socketOption.optionCode
        };
        if (!!Object.keys(configs).length) setSearchParams((0,index_es.cleanObject)(BuildPcModal_objectSpread({}, defaultSearchParams, configs, socketSearchParam)));
    }, [
        JSON.stringify(configs),
        JSON.stringify(filters),
        JSON.stringify(initialSocketOption), 
    ]);
    const renderContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcModalHeader_es/* BuildPcModalHeader */.t, {
                searchParams: searchParams,
                onClickSort: onSort,
                onClickFilter: onUpdateParams,
                filters: filters || [],
                activeValues: activeValues,
                isMobile: isMobile
            }),
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcMobileModalContent, {
                isLoading: isLoading,
                onClick: (sku)=>{
                    onSelectProduct(sku);
                    onHide();
                },
                products: products.map(convertNewProductCard)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcModalContent_es/* BuildPcModalContent */.b, {
                isLoading: isLoading,
                onClick: (sku)=>{
                    onSelectProduct(sku);
                    onHide();
                },
                products: products.map(convertNewProductCard)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPagination, {
                    totalRecords: result.pagination.totalItems || 0,
                    pageLimit: searchParams.limit || 0,
                    onPageChanged: (pageNum)=>{
                        setSearchParams(BuildPcModal_objectSpreadProps(BuildPcModal_objectSpread({}, searchParams), {
                            page: pageNum
                        }));
                    },
                    currentPage: searchParams.page || 1,
                    pageNeighbours: isMobile ? 0 : 2
                })
            })
        ]
    });
    return !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
        children: renderContent
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMobile, {
        children: renderContent
    });
};

// EXTERNAL MODULE: ./hooks/banners.ts
var banners = __webpack_require__(700074);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Breadcrumbs/Breadcrumbs.es.js
var Breadcrumbs_es = __webpack_require__(955006);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Card/Card.es.js
var Card_Card_es = __webpack_require__(319326);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../packages/utils/dist/string.es.js
var string_es = __webpack_require__(679376);
;// CONCATENATED MODULE: ./containers/BuildPc/pageDescriptionContent.ts
const pageDescriptionContent = '<p style="margin-left:0cm;">Năm 2025 chứng kiến sự b\xf9ng nổ của c\xf4ng nghệ, k\xe9o theo đ\xf3 l\xe0 sự ph\xe1t triển mạnh mẽ của thị trường linh kiện m\xe1y t\xednh. Việc tự <a href="https://phongvu.vn/buildpc"><span style="color:#1155CC;"><strong>build PC</strong></span></a> trở n\xean dễ d\xe0ng hơn bao giờ hết nhờ sự đa dạng về sản phẩm v\xe0 sự sẵn c\xf3 tr\xean c\xe1c s\xe0n thương mại điện tử uy t\xedn. Hướng dẫn chi tiết n\xe0y sẽ cung cấp cho bạn kiến thức to\xe0n diện để lựa chọn linh kiện ph\xf9 hợp v\xe0 lắp r\xe1p PC tại nh\xe0 một c\xe1ch chuy\xean nghiệp, đ\xe1p ứng mọi nhu cầu từ chơi game, l\xe0m việc đến s\xe1ng tạo nội dung. C\xf9ng <strong>Phong Vũ</strong> xem ở nội dung chi tiết b\xean dưới nh\xe9.</p><figure class="image"><img src="https://storage.googleapis.com/staging.teko-gae.appspot.com/media/image/2025/1/17/2b91d1f1-74e0-4d8f-9d9f-b4d9e795f696/image.jpeg"><figcaption>Build PC cấu h\xecnh m\xe1y t\xednh ng\xe0y c\xe0ng trở n\xean phổ biến khi c\xe1 nh\xe2n ho\xe1 được nhu cầu, cấu h\xecnh người d\xf9ng.</figcaption></figure><h2 style="margin-left:0cm;">Build PC - X\xe2y dựng cấu h\xecnh m\xe1y t\xednh l\xe0 g\xec?</h2><p style="margin-left:0cm;">Build PC kh\xf4ng chỉ đơn thuần l\xe0 lắp gh\xe9p c\xe1c <strong>linh kiện PC</strong>, đ\xf3 c\xf2n l\xe0 một qu\xe1 tr\xecnh s\xe1ng tạo, cho ph\xe9p bạn t\xf9y biến cấu h\xecnh m\xe1y t\xednh theo sở th\xedch v\xe0 nhu cầu c\xe1 nh\xe2n. So với việc mua PC lắp sẵn, tự build PC mang lại nhiều lợi \xedch như tiết kiệm chi ph\xed, tối ưu hiệu năng v\xe0 đặc biệt l\xe0 sự am hiểu s\xe2u sắc về từng linh kiện b\xean trong cỗ m\xe1y của m\xecnh.</p><figure class="image"><img src="https://storage.googleapis.com/staging.teko-gae.appspot.com/media/image/2025/1/17/833d2590-173f-4141-9faf-47c58b1cd754/image.jpeg" alt="Tự build PC để tối ưu hiệu năng chơi game, thể hiện c\xe1 t\xednh v\xe0 tiết kiệm chi ph\xed"><figcaption><i>Tự build PC để tối ưu hiệu năng chơi game, thể hiện c\xe1 t\xednh v\xe0 tiết kiệm chi ph\xed</i></figcaption></figure><h2 style="margin-left:0cm;"><strong>Trước khi build PC, cần lưu \xfd c\xe1c ti\xeau ch\xed g\xec?</strong></h2><p style="margin-left:0cm;">Trước khi đi v\xe0o chi tiết từng <a href="https://phongvu.vn/c/linh-kien-may-tinh"><span style="color:#1155CC;"><strong>linh kiện PC</strong></span></a>, việc chuẩn bị kỹ lưỡng l\xe0 bước đệm quan trọng đảm bảo qu\xe1 tr\xecnh build PC diễn ra su\xf4n sẻ v\xe0 hiệu quả. Bạn cần x\xe1c định r\xf5 r\xe0ng mục đ\xedch sử dụng, ng\xe2n s\xe1ch dự kiến v\xe0 trang bị kiến thức cơ bản về c\xe1c th\xe0nh phần cấu th\xe0nh n\xean một bộ PC ho\xe0n chỉnh.</p><ul><li><strong>X\xe1c định nhu cầu sử dụng:</strong> Đ\xe2y l\xe0 yếu tố then chốt quyết định cấu h\xecnh PC của bạn. H\xe3y tự hỏi bản th\xe2n: "Bạn cần PC để l\xe0m g\xec?". Nhu cầu chơi game Esport, game AAA nặng đồ họa, l\xe0m việc văn ph\xf2ng, đồ họa chuy\xean nghiệp, lập tr\xecnh, hay dựng phim sẽ đ\xf2i hỏi những cấu h\xecnh kh\xe1c nhau. V\xed dụ, nếu bạn chủ yếu chơi game Esport, FPS cao v\xe0 độ trễ thấp l\xe0 ưu ti\xean h\xe0ng đầu, trong khi đồ họa c\xf3 thể kh\xf4ng cần qu\xe1 cầu kỳ. Ngược lại, nếu bạn l\xe0m đồ họa chuy\xean nghiệp, CPU nhiều nh\xe2n, nhiều luồng v\xe0 VGA mạnh mẽ sẽ l\xe0 những yếu tố quan trọng.</li><li><strong>X\xe1c định ng\xe2n s\xe1ch:</strong> Sau khi x\xe1c định nhu cầu, h\xe3y đặt ra một mức ng\xe2n s\xe1ch cụ thể cho bộ PC. Điều n\xe0y gi\xfap bạn khoanh v\xf9ng lựa chọn linh kiện ph\xf9 hợp, tr\xe1nh t\xecnh trạng chi ti\xeau vượt qu\xe1 khả năng. H\xe3y nhớ rằng, build PC l\xe0 một khoản đầu tư d\xe0i hạn, v\xec vậy h\xe3y c\xe2n nhắc kỹ lưỡng v\xe0 lựa chọn linh kiện c\xf3 chất lượng tốt, đảm bảo hiệu năng v\xe0 độ bền trong thời gian d\xe0i. Ng\xe2n s\xe1ch sẽ ảnh hưởng trực tiếp đến việc lựa chọn c\xe1c linh kiện chủ chốt như CPU, VGA, RAM, SSD, nguồn, vỏ case, v\xe0 tản nhiệt.</li><li><strong>T\xecm hiểu về linh kiện:</strong> Trước khi mua bất kỳ linh kiện n\xe0o, h\xe3y d\xe0nh thời gian t\xecm hiểu về ch\xfang. Đọc c\xe1c b\xe0i đ\xe1nh gi\xe1, so s\xe1nh th\xf4ng số kỹ thuật, xem c\xe1c video hướng dẫn build PC tr\xean YouTube, tham gia c\xe1c diễn đ\xe0n, cộng đồng build PC để học hỏi kinh nghiệm từ những người đi trước. Việc n\xe0y gi\xfap bạn c\xf3 c\xe1i nh\xecn tổng quan về thị trường linh kiện, nắm bắt được xu hướng c\xf4ng nghệ mới nhất v\xe0 lựa chọn được những sản phẩm ph\xf9 hợp nhất với nhu cầu v\xe0 ng\xe2n s\xe1ch của m\xecnh.</li></ul><h2 style="margin-left:0cm;"><strong>Build PC cần lưu \xfd ở c\xe1c linh kiện n\xe0o - th\xf4ng số kỹ thuật n\xe0o với c\xe1c linh kiện</strong></h2><h3 style="margin-left:0cm;"><strong>CPU (Central Processing Unit - Bộ xử l\xfd trung t\xe2m)</strong></h3><p>CPU được v\xed như "bộ n\xe3o" của m\xe1y t\xednh, chịu tr\xe1ch nhiệm xử l\xfd mọi t\xe1c vụ từ đơn giản đến phức tạp. Một CPU mạnh mẽ với xung nhịp cao, nhiều nh\xe2n v\xe0 luồng xử l\xfd sẽ đảm bảo hiệu năng mượt m\xe0 cho c\xe1c t\xe1c vụ nặng như chơi game, render video hay thiết kế đồ họa. <strong>Xung nhịp</strong> được đo bằng GHz, thể hiện số lượng ph\xe9p t\xednh m\xe0 CPU c\xf3 thể thực hiện trong một gi\xe2y. <strong>Số nh\xe2n</strong> cho biết CPU c\xf3 bao nhi\xeau l\xf5i xử l\xfd, mỗi l\xf5i c\xf3 khả năng xử l\xfd một luồng dữ liệu ri\xeang biệt. <strong>Số luồng</strong> l\xe0 số lượng luồng dữ liệu m\xe0 CPU c\xf3 thể xử l\xfd đồng thời, nhờ c\xf4ng nghệ si\xeau ph\xe2n luồng.</p><ul><li><strong>Vai tr\xf2:</strong> "Bộ n\xe3o" của m\xe1y t\xednh, quyết định tốc độ xử l\xfd c\xe1c t\xe1c vụ.</li><li><strong>Yếu tố quan t\xe2m:</strong><ul><li><strong>Số nh\xe2n/luồng:</strong> C\xe0ng nhiều nh\xe2n/luồng, khả năng xử l\xfd đa nhiệm c\xe0ng tốt.</li><li><strong>Xung nhịp (GHz):</strong> Xung nhịp c\xe0ng cao, tốc độ xử l\xfd đơn nh\xe2n c\xe0ng nhanh.</li><li><strong>Bộ nhớ đệm (Cache):</strong> Cache lớn gi\xfap truy cập dữ liệu nhanh hơn.</li><li><strong>Kiến tr\xfac (Architecture):</strong> Kiến tr\xfac mới hơn thường mang lại hiệu năng tốt hơn v\xe0 tiết kiệm điện hơn.</li><li><strong>Khả năng \xe9p xung:</strong> Cho ph\xe9p tăng hiệu năng CPU vượt mức mặc định.</li><li><strong>TDP (Thermal Design Power):</strong> Thể hiện mức ti\xeau thụ điện v\xe0 nhiệt lượng tỏa ra, cần chọn tản nhiệt ph\xf9 hợp.</li></ul></li></ul><figure class="image"><img src="https://storage.googleapis.com/staging.teko-gae.appspot.com/media/image/2025/1/17/2b51283c-a5be-47bf-a823-356777fc5f6c/image.jpeg" alt="Chọn CPU - bộ n\xe3o của PC - cần ch\xfa \xfd số nh\xe2n, luồng, xung nhịp v\xe0 socket tương th\xedch mainboard khi build PC"><figcaption>Cận cảnh CPU đang được lắp v\xe0o socket tr\xean mainboard trong qu\xe1 tr\xecnh build PC cho kh\xe1ch</figcaption></figure><h3 style="margin-left:0cm;">VGA (Video Graphics Card - Card đồ họa)</h3><p><strong>Card đồ họa</strong> chịu tr\xe1ch nhiệm xử l\xfd h\xecnh ảnh, đặc biệt quan trọng đối với game thủ, nh\xe0 thiết kế đồ họa v\xe0 những người l\xe0m việc với nội dung đa phương tiện. <strong>GPU</strong> (Graphics Processing Unit) l\xe0 bộ xử l\xfd chuy\xean dụng cho đồ họa, c\xf3 khả năng xử l\xfd song song v\xe0 tăng tốc hiển thị h\xecnh ảnh. <strong>Bộ nhớ VRAM</strong> tr\xean card đồ họa lưu trữ dữ liệu h\xecnh ảnh, dung lượng VRAM c\xe0ng lớn c\xe0ng xử l\xfd được h\xecnh ảnh ở độ ph\xe2n giải cao v\xe0 chi tiết hơn.</p><p>C\xe1c yếu tố kh\xe1c cần xem x\xe9t khi chọn card đồ họa bao gồm <strong>loại GPU</strong> (Nvidia GeForce, AMD Radeon), <strong>tốc độ xung nhịp</strong>, <strong>số lượng nh\xe2n CUDA</strong> (đối với Nvidia) hoặc <strong>Stream Processors</strong> (đối với AMD), <strong>giao tiếp PCIe</strong> v\xe0 <strong>c\xf4ng nghệ l\xe0m m\xe1t</strong>. Lựa chọn card đồ họa ph\xf9 hợp sẽ mang lại trải nghiệm h\xecnh ảnh tuyệt vời v\xe0 hiệu năng cao trong c\xe1c ứng dụng đồ họa.</p><ul><li><strong>Vai tr\xf2:</strong> Xử l\xfd h\xecnh ảnh, đặc biệt quan trọng cho gaming v\xe0 đồ họa.</li><li><strong>Yếu tố quan t\xe2m:</strong><ul><li><strong>GPU (Graphics Processing Unit):</strong> Chip xử l\xfd đồ họa, quyết định sức mạnh của VGA.</li><li><strong>VRAM (Video RAM):</strong> Dung lượng bộ nhớ đồ họa, ảnh hưởng đến khả năng xử l\xfd độ ph\xe2n giải cao v\xe0 texture nặng.</li><li><strong>Xung nhịp GPU:</strong> Tốc độ xử l\xfd của GPU.</li><li><strong>Số nh\xe2n CUDA (NVIDIA) / Stream Processors (AMD):</strong> C\xe0ng nhiều nh\xe2n, khả năng xử l\xfd đồ họa c\xe0ng mạnh.</li><li><strong>Hỗ trợ c\xf4ng nghệ:</strong> Ray Tracing, DLSS (NVIDIA), FSR (AMD) gi\xfap n\xe2ng cao chất lượng h\xecnh ảnh v\xe0 FPS.</li><li><strong>Băng th\xf4ng bộ nhớ:</strong> Tốc độ truyền tải dữ liệu giữa GPU v\xe0 VRAM.</li><li><strong>TDP:</strong> Cần chọn nguồn c\xf3 c\xf4ng suất ph\xf9 hợp.</li></ul></li></ul><figure class="image"><img src="https://storage.googleapis.com/staging.teko-gae.appspot.com/media/image/2025/1/17/0505694b-79ac-4ebe-b98e-25d29f211d5b/image.jpeg" alt="Card đồ họa VGA quyết định hiệu năng chơi game, cần quan t\xe2m GPU, VRAM v\xe0 c\xf4ng nghệ hỗ trợ như Ray Tracing, DLSS"><figcaption><i>Card m\xe0n h\xecnh RTX 5080 - hứa hẹn l\xe0 sự lựa chọn của nhiều bộ PC Gaming cao cấp trong thị trường build PC năm 2025</i></figcaption></figure><h3 style="margin-left:0cm;">Mainboard (Bo mạch chủ)</h3><p>Mainboard l\xe0 nền tảng kết nối tất cả c\xe1c linh kiện trong m\xe1y t\xednh. <strong>Chipset</strong> tr\xean mainboard quyết định khả năng hỗ trợ CPU, RAM, khe cắm mở rộng v\xe0 c\xe1c t\xednh năng kh\xe1c. <strong>Socket CPU</strong> phải tương th\xedch với CPU bạn đ\xe3 chọn. <strong>Khe cắm RAM</strong> quyết định loại RAM v\xe0 dung lượng RAM tối đa m\xe0 mainboard hỗ trợ.</p><ul><li><strong>Vai tr\xf2:</strong> Nền tảng kết nối tất cả c\xe1c linh kiện.</li><li><strong>Yếu tố quan t\xe2m:</strong><ul><li><strong>Socket:</strong> Phải tương th\xedch với CPU.</li><li><strong>Chipset:</strong> Quyết định c\xe1c t\xednh năng hỗ trợ (\xe9p xung, số khe RAM, cổng kết nối...).</li><li><strong>Khe cắm RAM:</strong> Loại RAM (DDR4, DDR5) v\xe0 số khe cắm.</li><li><strong>Khe cắm PCIe:</strong> Cho VGA v\xe0 c\xe1c card mở rộng kh\xe1c.</li><li><strong>Cổng kết nối:</strong> USB, SATA, M.2, LAN, Wi-Fi, Bluetooth...</li><li><strong>VRM (Voltage Regulator Module):</strong> Cung cấp điện cho CPU, VRM tốt gi\xfap CPU hoạt động ổn định, đặc biệt khi \xe9p xung.</li><li><strong>BIOS:</strong> Dễ sử dụng, nhiều t\xednh năng t\xf9y chỉnh.</li></ul></li></ul><figure class="image"><img src="https://storage.googleapis.com/staging.teko-gae.appspot.com/media/image/2025/1/17/eadc7ae0-596f-4a14-868e-043a8c4c2ad9/image.jpeg" alt="Mainboard l\xe0 nền tảng kết nối mọi linh kiện, cần chọn chipset ph\xf9 hợp CPU, đủ cổng kết nối v\xe0 VRM chất lượng."><figcaption><i>Cận cảnh một bo mạch chủ (mainboard) Z890 &nbsp;từ Asus với đầy đủ c\xe1c khe cắm, cổng kết nối v\xe0 hệ thống VRM tản nhiệt</i></figcaption></figure><h3 style="margin-left:0cm;"><strong>RAM (Random Access Memory - Bộ nhớ truy cập ngẫu nhi\xean)</strong></h3><p>RAM l\xe0 bộ nhớ tạm thời, nơi lưu trữ dữ liệu v\xe0 chương tr\xecnh đang được sử dụng. <strong>Dung lượng RAM</strong> c\xe0ng lớn, m\xe1y t\xednh c\xe0ng c\xf3 thể xử l\xfd nhiều t\xe1c vụ c\xf9ng l\xfac m\xe0 kh\xf4ng bị giật lag. <strong>Tốc độ RAM</strong> (đo bằng MHz) ảnh hưởng đến tốc độ truy xuất dữ liệu, gi\xfap hệ thống hoạt động nhanh hơn.</p><p>Khi chọn RAM, cần lưu \xfd đến <strong>loại RAM</strong> (DDR4, DDR5), <strong>dung lượng</strong> (8GB, 16GB, 32GB...), <strong>tốc độ bus</strong> v\xe0 <strong>độ trễ CAS Latency</strong>. Ngo\xe0i ra, n\xean chọn RAM c\xf3 c\xf9ng th\xf4ng số v\xe0 từ c\xf9ng một nh\xe0 sản xuất để đảm bảo t\xednh ổn định v\xe0 tương th\xedch. RAM l\xe0 một trong những yếu tố quan trọng ảnh hưởng đến hiệu năng tổng thể của <strong>PC</strong>, đặc biệt l\xe0 trong c\xe1c t\xe1c vụ đa nhiệm v\xe0 xử l\xfd dữ liệu nặng.</p><ul><li><strong>Vai tr\xf2:</strong> Lưu trữ dữ liệu tạm thời cho CPU xử l\xfd.</li><li><strong>Yếu tố quan t\xe2m:</strong><ul><li><strong>Dung lượng (GB):</strong> C\xe0ng nhiều c\xe0ng tốt cho đa nhiệm, khuyến nghị tối thiểu 16GB cho gaming.</li><li><strong>Tốc độ (MHz):</strong> Tốc độ c\xe0ng cao, băng th\xf4ng c\xe0ng lớn, gi\xfap CPU truy cập dữ liệu nhanh hơn.</li><li><strong>Độ trễ (CAS Latency - CL):</strong> CL c\xe0ng thấp, RAM phản hồi c\xe0ng nhanh.</li><li><strong>Loại RAM (DDR4, DDR5):</strong> DDR5 c\xf3 tốc độ cao hơn DDR4.</li><li><strong>Dual Channel/Quad Channel:</strong> Chạy RAM ở chế độ đa k\xeanh gi\xfap tăng băng th\xf4ng.</li></ul></li></ul><figure class="image"><img src="https://storage.googleapis.com/staging.teko-gae.appspot.com/media/image/2025/1/17/5b18390d-c89d-4654-85c3-98f94b886b51/image.jpeg" alt="Dung lượng RAM c\xe0ng cao, PC của bạn c\xe0ng c\xf3 thể xử l\xfd nhiều chương tr\xecnh v\xe0 dữ liệu c\xf9ng một l\xfac."><figcaption>Dung lượng RAM c\xe0ng cao, PC của bạn c\xe0ng c\xf3 thể xử l\xfd nhiều chương tr\xecnh v\xe0 dữ liệu c\xf9ng một l\xfac.</figcaption></figure><h3 style="margin-left:0cm;">SSD (Solid State Drive - Ổ cứng thể rắn)</h3><p><strong>Ổ cứng</strong> l\xe0 nơi lưu trữ hệ điều h\xe0nh, phần mềm v\xe0 dữ liệu c\xe1 nh\xe2n. Hiện nay c\xf3 hai loại ổ cứng phổ biến l\xe0 <strong>HDD</strong> (ổ cứng cơ học) v\xe0 <strong>SSD</strong> (ổ cứng thể rắn). <strong>SSD</strong> c\xf3 tốc độ đọc ghi dữ liệu nhanh hơn <strong>HDD</strong> nhiều lần, gi\xfap khởi động m\xe1y, mở ứng dụng v\xe0 truy xuất dữ liệu nhanh ch\xf3ng.</p><p><strong>Dung lượng ổ cứng</strong> được đo bằng GB hoặc TB, lựa chọn dung lượng ph\xf9 hợp với nhu cầu lưu trữ của bạn. Ngo\xe0i ra, c\xf3 thể kết hợp <strong>SSD</strong> v\xe0 <strong>HDD</strong> trong c\xf9ng một hệ thống để tận dụng ưu điểm của cả hai loại ổ cứng. <strong>SSD</strong> d\xf9ng để c\xe0i đặt hệ điều h\xe0nh v\xe0 phần mềm, <strong>HDD</strong> d\xf9ng để lưu trữ dữ liệu dung lượng lớn.</p><ul><li><strong>Vai tr\xf2:</strong> Lưu trữ hệ điều h\xe0nh, ứng dụng v\xe0 dữ liệu.</li><li><strong>Yếu tố quan t\xe2m:</strong><ul><li><strong>Loại SSD:</strong> NVMe (PCIe) nhanh hơn nhiều so với SATA.</li><li><strong>Dung lượng (GB/TB):</strong> T\xf9y theo nhu cầu lưu trữ.</li><li><strong>Tốc độ đọc/ghi (MB/s):</strong> C\xe0ng cao, thời gian load game, ứng dụng v\xe0 truyền tải dữ liệu c\xe0ng nhanh.</li><li><strong>TBW (Total Bytes Written):</strong> Độ bền của SSD, thể hiện lượng dữ liệu c\xf3 thể ghi v\xe0o SSD trước khi n\xf3 hỏng.</li></ul></li></ul><figure class="image"><img src="https://storage.googleapis.com/staging.teko-gae.appspot.com/media/image/2025/1/17/9c3a880f-6fb4-49b0-b586-18a7343fd7d4/image.jpeg" alt="Ổ cứng SSD NVMe cho tốc độ vượt trội, n\xean chọn dung lượng ph\xf9 hợp v\xe0 ưu ti\xean PCIe 4.0 cho hiệu năng cao nhất"><figcaption>Ổ cứng SSD NVMe PCIe 4.0 đang được lắp v\xe0o khe M.2 tr\xean mainboard</figcaption></figure><h3 style="margin-left:0cm;">Nguồn (Power Supply Unit - PSU)</h3><p><strong>Nguồn điện</strong> cung cấp năng lượng cho to\xe0n bộ hệ thống <strong>PC</strong>. <strong>C\xf4ng suất nguồn</strong> (đo bằng Watt) phải đủ đ\xe1p ứng nhu cầu của tất cả c\xe1c linh kiện. N\xean chọn nguồn c\xf3 c\xf4ng suất dư ra khoảng 30% để đảm bảo ổn định v\xe0 khả năng n\xe2ng cấp sau n\xe0y. <strong>Hiệu suất nguồn</strong> được thể hiện bằng chứng nhận 80 PLUS (White, Bronze, Silver, Gold, Platinum, Titanium), chứng nhận c\xe0ng cao th\xec hiệu suất c\xe0ng lớn, tiết kiệm điện năng v\xe0 tỏa nhiệt \xedt hơn.</p><ul><li><strong>Vai tr\xf2:</strong> Cung cấp điện cho to\xe0n bộ hệ thống.</li><li><strong>Yếu tố quan t\xe2m:</strong><ul><li><strong>C\xf4ng suất (W):</strong> Phải đủ cung cấp cho tất cả c\xe1c linh kiện, n\xean chọn dư ra một ch\xfat để đảm bảo ổn định v\xe0 n\xe2ng cấp về sau.</li><li><strong>Hiệu suất (80 Plus):</strong> Chứng nhận hiệu suất chuyển đổi điện năng, 80 Plus Gold trở l\xean được khuyến nghị.</li><li><strong>Thương hiệu:</strong> Chọn nguồn từ thương hiệu uy t\xedn để đảm bảo chất lượng v\xe0 độ bền.</li><li>Độ ồn: Nguồn tốt thường vận h\xe0nh \xeam \xe1i hơn.</li><li><strong>Dạng module (Full/Semi/Non-Modular):</strong> Full modular cho ph\xe9p đi d\xe2y gọn g\xe0ng hơn.</li></ul></li></ul><figure class="image"><img src="https://storage.googleapis.com/staging.teko-gae.appspot.com/media/image/2025/1/17/e482c5b2-0f55-446a-8bec-57fab23e5de3/image.jpeg" alt="Nguồn m\xe1y t\xednh cung cấp năng lượng cho to\xe0n bộ hệ thống, cần chọn c\xf4ng suất ph\xf9 hợp, hiệu suất cao v\xe0 thương hiệu uy t\xedn."><figcaption><i>Nguồn m\xe1y t\xednh 850W 80 Plus Gold của Gigabyte với c\xe1c d\xe2y c\xe1p được sắp xếp gọn g\xe0ng trước khi lắp v\xe0o bộ PC Gaming cho kh\xe1ch</i></figcaption></figure><h3 style="margin-left:0cm;">Tản nhiệt (Cooling)</h3><p><strong>Tản nhiệt CPU</strong> gi\xfap l\xe0m m\xe1t CPU, ngăn ngừa qu\xe1 nhiệt v\xe0 đảm bảo hoạt động ổn định. C\xf3 hai loại tản nhiệt ch\xednh l\xe0 <strong>tản nhiệt kh\xed</strong> v\xe0 <strong>tản nhiệt nước</strong>. <strong>Tản nhiệt kh\xed</strong> sử dụng quạt v\xe0 phiến nh\xf4m để tản nhiệt, c\xf3 gi\xe1 th\xe0nh rẻ v\xe0 dễ lắp đặt. <strong>Tản nhiệt nước</strong> sử dụng chất lỏng để tản nhiệt, c\xf3 hiệu quả l\xe0m m\xe1t cao hơn nhưng gi\xe1 th\xe0nh đắt hơn v\xe0 lắp đặt phức tạp hơn.</p><ul><li><strong>Vai tr\xf2:</strong> Giữ cho c\xe1c linh kiện hoạt động ở nhiệt độ ổn định.</li><li><strong>Yếu tố quan t\xe2m:</strong><ul><li><strong>Tản nhiệt CPU:</strong> Tản nhiệt kh\xed hoặc tản nhiệt nước (AIO), phải tương th\xedch với socket CPU v\xe0 đủ khả năng tản nhiệt cho CPU.</li><li><strong>Tản nhiệt VGA:</strong> Thường đi k\xe8m với VGA, cần quan t\xe2m đến độ ồn v\xe0 hiệu quả tản nhiệt.</li><li><strong>Quạt case:</strong> Gi\xfap lưu th\xf4ng kh\xed trong case, số lượng v\xe0 vị tr\xed lắp quạt ảnh hưởng đến hiệu quả l\xe0m m\xe1t.</li><li><strong>Luồng kh\xed (Airflow):</strong> Thiết kế case v\xe0 c\xe1ch bố tr\xed quạt ảnh hưởng đến luồng kh\xed, cần đảm bảo luồng kh\xed lưu th\xf4ng tốt.</li></ul></li></ul><figure class="image"><img src="https://storage.googleapis.com/staging.teko-gae.appspot.com/media/image/2025/1/17/f001c9e9-157d-4c24-aaa5-65fe357b9b89/image.jpeg" alt="Tản nhiệt CPU gi\xfap CPU hoạt động m\xe1t mẻ, ổn định, n\xean chọn loại ph\xf9 hợp với TDP của CPU v\xe0 k\xedch thước case."><figcaption><i>Một bộ tản nhiệt kh\xed CPU cao cấp với nhiều ống đồng v\xe0 quạt lớn</i></figcaption></figure><h3 style="margin-left:0cm;">Vỏ Case (Case)</h3><ul><li><strong>Vai tr\xf2:</strong> Bảo vệ c\xe1c linh kiện v\xe0 tạo thẩm mỹ cho PC.</li><li><strong>Yếu tố quan t\xe2m:</strong><ul><li><strong>K\xedch thước (Form Factor):</strong> Phải tương th\xedch với mainboard (ATX, Micro-ATX, Mini-ITX).</li><li><strong>Khả năng hỗ trợ tản nhiệt:</strong> Chiều cao tản nhiệt kh\xed, k\xedch thước radiator tản nhiệt nước.</li><li><strong>Khả năng hỗ trợ VGA:</strong> Chiều d\xe0i VGA tối đa.</li><li><strong>Luồng kh\xed (Airflow):</strong> Thiết kế case c\xf3 tho\xe1ng m\xe1t, c\xf3 nhiều vị tr\xed lắp quạt hay kh\xf4ng.</li><li><strong>Chất liệu:</strong> Độ bền, khả năng chống ồn.</li><li><strong>Thẩm mỹ:</strong> Thiết kế, m\xe0u sắc, đ\xe8n LED RGB...</li></ul></li></ul><p style="margin-left:0cm;">&nbsp;</p><h2 style="margin-left:0cm;"><strong>Build PC với c\xe1c cấu h\xecnh, nhu cầu v\xe0 ph\xe2n kh\xfac cần lưu \xfd g\xec</strong></h2><p style="margin-left:0cm;">Việc lựa chọn linh kiện l\xe0 bước quan trọng nhất trong qu\xe1 tr\xecnh build PC. Dưới đ\xe2y l\xe0 hướng dẫn chi tiết c\xe1ch chọn linh kiện ph\xf9 hợp cho từng ph\xe2n kh\xfac v\xe0 nhu cầu sử dụng, đảm bảo bạn c\xf3 một bộ PC mạnh mẽ, ổn định v\xe0 tối ưu nhất.</p><h3 style="margin-left:0cm;">Build PC Gaming cho c\xe1c tựa game Esport</h3><h4 style="margin-left:0cm;">Ph\xe2n kh\xfac tầm trung (17-18 triệu):</h4><ul><li><strong>Mục ti\xeau:</strong> Chơi mượt c\xe1c tựa game Esport phổ biến (Li\xean Minh Huyền Thoại, CS:GO, Valorant, Dota 2...) ở độ ph\xe2n giải Full HD, setting cao, FPS ổn định 144Hz - 240Hz.</li><li><strong>Cấu h\xecnh gợi \xfd:</strong></li></ul><figure class="table"><table><tbody><tr><td><strong>Linh kiện</strong></td><td><strong>Option 1</strong></td><td><strong>Option 2</strong></td><td><strong>Option 3</strong></td></tr><tr><td><strong>CPU</strong></td><td>Intel Core i5-12400F</td><td>Intel Core i3-13100F</td><td>AMD Ryzen 5 5600</td></tr><tr><td><strong>Mainboard</strong></td><td>Chipset Intel B660, DDR4</td><td>Chipset Intel B660, DDR4</td><td>Chipset AMD B550</td></tr><tr><td><strong>RAM</strong></td><td>16GB (2x8GB) DDR4 3200MHz</td><td>16GB (2x8GB) DDR4 3200MHz</td><td>16GB (2x8GB) DDR4 3600MHz</td></tr><tr><td><strong>VGA</strong></td><td>NVIDIA GeForce RTX 3050 8GB</td><td>NVIDIA GeForce RTX 4060 8GB</td><td>AMD Radeon RX 6600 8GB</td></tr><tr><td><strong>SSD</strong></td><td>500-512GB NVMe PCIe 3.0 hoặc 4.0</td><td>500-512GB NVMe PCIe 3.0 hoặc 4.0</td><td>500-512GB NVMe PCIe 3.0</td></tr><tr><td><strong>Nguồn</strong></td><td>550W - 650W 80+ Bronze</td><td>550W - 650W 80+ Bronze</td><td>650W 80+ Bronze</td></tr><tr><td><strong>Vỏ Case</strong></td><td>Mid-tower, hỗ trợ mainboard ATX/Micro-ATX, tho\xe1ng kh\xed</td><td>Mid-tower, hỗ trợ mainboard ATX/Micro-ATX, tho\xe1ng kh\xed</td><td>Mid-tower, hỗ trợ mainboard ATX/Micro-ATX, tho\xe1ng kh\xed</td></tr><tr><td><strong>Tản nhiệt</strong></td><td>Tản nhiệt kh\xed tầm trung, hỗ trợ socket CPU</td><td>Tản nhiệt kh\xed tầm trung, hỗ trợ socket CPU</td><td>Tản nhiệt kh\xed tầm trung, hỗ trợ socket CPU</td></tr></tbody></table></figure><h4 style="margin-left:0cm;">Ph\xe2n kh\xfac cao cấp (20-25 triệu):</h4><ul><li><strong>Mục ti\xeau:</strong> Chơi mượt c\xe1c tựa game Esport ở độ ph\xe2n giải Full HD, setting max, FPS cao 240Hz+ hoặc 1440p, setting cao.</li><li><strong>Cấu h\xecnh gợi \xfd:</strong></li></ul><figure class="table"><table><tbody><tr><td><strong>Linh kiện</strong></td><td><strong>Option 1</strong></td><td><strong>Option 2</strong></td><td><strong>Option 3</strong></td></tr><tr><td><strong>CPU</strong></td><td>Intel Core i5-13400F</td><td>AMD Ryzen 5 7500F</td><td>Intel Core i5-12600KF</td></tr><tr><td><strong>Mainboard</strong></td><td>Chipset Intel B760, DDR4</td><td>Chipset AMD B650, DDR5</td><td>Chipset Intel B660, DDR4</td></tr><tr><td><strong>RAM</strong></td><td>16GB (2x8GB) DDR4 3600MHz</td><td>16GB (2x8GB) DDR5 5600MHz</td><td>16GB (2x8GB) DDR4 3600MHz</td></tr><tr><td><strong>VGA</strong></td><td>NVIDIA GeForce RTX 4060 8GB</td><td>NVIDIA GeForce RTX 3060 Ti 8GB</td><td>AMD Radeon RX 6700 XT 12GB</td></tr><tr><td><strong>SSD</strong></td><td>1TB NVMe PCIe 4.0</td><td>1TB NVMe PCIe 4.0</td><td>1TB NVMe PCIe 4.0</td></tr><tr><td><strong>Nguồn</strong></td><td>650W 80+ Gold</td><td>650W 80+ Gold</td><td>650W 80+ Gold</td></tr><tr><td><strong>Vỏ Case</strong></td><td>Mid-tower, hỗ trợ mainboard ATX/Micro-ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td><td>Mid-tower, hỗ trợ mainboard ATX/Micro-ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td><td>Mid-tower, hỗ trợ mainboard ATX/Micro-ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td></tr><tr><td><strong>Tản nhiệt</strong></td><td>Tản nhiệt kh\xed tầm trung, hỗ trợ socket CPU</td><td>Tản nhiệt kh\xed tầm trung, hỗ trợ socket CPU</td><td>Tản nhiệt kh\xed tầm trung, hỗ trợ socket CPU</td></tr></tbody></table></figure><h4 style="margin-left:0cm;">Ph\xe2n kh\xfac cao cấp (26-30 triệu):</h4><ul><li><strong>Mục ti\xeau:</strong> Chơi mượt c\xe1c tựa game Esport ở độ ph\xe2n giải 1440p hoặc Full HD, setting max, FPS cao 240Hz+.</li><li><strong>Cấu h\xecnh gợi \xfd:</strong></li></ul><figure class="table"><table><tbody><tr><td><strong>Linh kiện</strong></td><td><strong>Option 1</strong></td><td><strong>Option 2</strong></td><td><strong>Option 3</strong></td></tr><tr><td><strong>CPU</strong></td><td>Intel Core i5-13600KF</td><td>AMD Ryzen 7 5700X3D</td><td>AMD Ryzen 5 7600X</td></tr><tr><td><strong>Mainboard</strong></td><td>Chipset Intel Z790, DDR4</td><td>Chipset AMD B550</td><td>Chipset AMD B650, DDR5</td></tr><tr><td><strong>RAM</strong></td><td>32GB (2x16GB) DDR4 3600MHz</td><td>32GB (2x16GB) DDR4 3600MHz</td><td>32GB (2x16GB) DDR5 6000MHz</td></tr><tr><td><strong>VGA</strong></td><td>NVIDIA GeForce RTX 4060 Ti 8GB</td><td>NVIDIA GeForce RTX 3070 8GB (cũ)</td><td>AMD Radeon RX 6800 16GB</td></tr><tr><td><strong>SSD</strong></td><td>1TB NVMe PCIe 4.0</td><td>1TB NVMe PCIe 4.0</td><td>1TB NVMe PCIe 4.0</td></tr><tr><td><strong>Nguồn</strong></td><td>750W 80+ Gold</td><td>750W 80+ Gold</td><td>750W 80+ Gold</td></tr><tr><td><strong>Vỏ Case</strong></td><td>Mid-tower hoặc Full-tower, hỗ trợ mainboard ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td><td>Mid-tower hoặc Full-tower, hỗ trợ mainboard ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td><td>Mid-tower hoặc Full-tower, hỗ trợ mainboard ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td></tr><tr><td><strong>Tản nhiệt</strong></td><td>Tản nhiệt kh\xed cao cấp hoặc AIO 240mm - 280mm, hỗ trợ socket CPU</td><td>Tản nhiệt kh\xed cao cấp hoặc AIO 240mm - 280mm, hỗ trợ socket CPU</td><td>Tản nhiệt kh\xed cao cấp hoặc AIO 240mm - 280mm, hỗ trợ socket CPU</td></tr></tbody></table></figure><h4 style="margin-left:0cm;">Ph\xe2n kh\xfac cao cấp (35-40 triệu):</h4><ul><li><strong>Mục ti\xeau:</strong> Đạt thiết lập đồ họa tối đa ở tất cả c\xe1c tựa game Esport tại độ ph\xe2n giải 1440p hoặc Full HD, FPS 240Hz+ hoặc cao hơn, đồng thời chơi tốt một số tựa game AAA.</li><li><strong>Cấu h\xecnh gợi \xfd:</strong></li></ul><figure class="table"><table><tbody><tr><td><strong>Linh kiện</strong></td><td><strong>Option 1</strong></td><td><strong>Option 2</strong></td><td><strong>Option 3</strong></td></tr><tr><td><strong>CPU</strong></td><td>AMD Ryzen 7 7800X3D</td><td>Intel Core i7-13700KF</td><td>Intel Core i7-14700KF</td></tr><tr><td><strong>Mainboard</strong></td><td>Chipset AMD X670E</td><td>Chipset Intel Z790</td><td>Chipset Intel Z790</td></tr><tr><td><strong>RAM</strong></td><td>32GB (2x16GB) DDR5 6000MHz</td><td>32GB (2x16GB) DDR5 6400MHz</td><td>32GB (2x16GB) DDR5 6000MHz</td></tr><tr><td><strong>VGA</strong></td><td>NVIDIA GeForce RTX 4070 Super 12GB</td><td>NVIDIA GeForce RTX 4070 12GB</td><td>AMD Radeon RX 7800 XT 16GB</td></tr><tr><td><strong>SSD</strong></td><td>2TB NVMe PCIe 4.0</td><td>2TB NVMe PCIe 4.0</td><td>2TB NVMe PCIe 4.0</td></tr><tr><td><strong>Nguồn</strong></td><td>850W 80+ Gold/Platinum</td><td>850W 80+ Gold/Platinum</td><td>850W 80+ Gold/Platinum</td></tr><tr><td><strong>Vỏ Case</strong></td><td>Full-tower, hỗ trợ mainboard E-ATX/ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td><td>Full-tower, hỗ trợ mainboard E-ATX/ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td><td>Full-tower, hỗ trợ mainboard E-ATX/ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td></tr><tr><td><strong>Tản nhiệt</strong></td><td>AIO 360mm, hỗ trợ socket CPU</td><td>AIO 360mm, hỗ trợ socket CPU</td><td>AIO 360mm, hỗ trợ socket CPU</td></tr></tbody></table></figure><h3 style="margin-left:0cm;">Build PC Gaming cho c\xe1c tựa game AAA</h3><h4 style="margin-left:0cm;">Ph\xe2n kh\xfac tầm trung (15-20 triệu):</h4><ul><li><strong>Mục ti\xeau:</strong> Chơi mượt c\xe1c tựa game AAA ở độ ph\xe2n giải Full HD (1080p), thiết lập đồ họa Cao (High Settings) đến Ultra, đạt mức khung h\xecnh ổn định 60 FPS, c\xf3 thể sử dụng c\xf4ng nghệ DLSS để tăng cường FPS ở c\xe1c tựa game hỗ trợ.</li><li><strong>Cấu h\xecnh gợi \xfd:</strong></li></ul><figure class="table"><table><tbody><tr><td><strong>Linh kiện</strong></td><td><strong>Option 1</strong></td><td><strong>Option 2</strong></td><td><strong>Option 3</strong></td></tr><tr><td><strong>CPU</strong></td><td>Intel Core i5-12400F</td><td>AMD Ryzen 5 5600</td><td>Intel Core i3-14100F</td></tr><tr><td><strong>Mainboard</strong></td><td>Chipset Intel B660, DDR4</td><td>Chipset AMD B550</td><td>Chipset Intel B760, DDR4</td></tr><tr><td><strong>RAM</strong></td><td>16GB (2x8GB) DDR4 3200MHz</td><td>16GB (2x8GB) DDR4 3200MHz</td><td>16GB (2x8GB) DDR4 3600MHz</td></tr><tr><td><strong>VGA</strong></td><td>NVIDIA GeForce RTX 3060 12GB</td><td>NVIDIA GeForce RTX 4060 8GB</td><td>AMD Radeon RX 6650 XT 8GB</td></tr><tr><td><strong>SSD</strong></td><td>500GB-1TB NVMe PCIe 3.0 hoặc 4.0</td><td>500GB-1TB NVMe PCIe 3.0 hoặc 4.0</td><td>500GB-1TB NVMe PCIe 3.0</td></tr><tr><td><strong>Nguồn</strong></td><td>650W 80+ Bronze</td><td>650W 80+ Bronze</td><td>650W 80+ Bronze</td></tr><tr><td><strong>Vỏ Case</strong></td><td>Mid-tower, hỗ trợ mainboard ATX/Micro-ATX, tho\xe1ng kh\xed</td><td>Mid-tower, hỗ trợ mainboard ATX/Micro-ATX, tho\xe1ng kh\xed</td><td>Mid-tower, hỗ trợ mainboard ATX/Micro-ATX, tho\xe1ng kh\xed</td></tr><tr><td><strong>Tản nhiệt</strong></td><td>Tản nhiệt kh\xed tầm trung, hỗ trợ socket CPU</td><td>Tản nhiệt kh\xed tầm trung, hỗ trợ socket CPU</td><td>Tản nhiệt kh\xed tầm trung, hỗ trợ socket CPU</td></tr></tbody></table></figure><h4 style="margin-left:0cm;">Ph\xe2n kh\xfac cao cấp (21-25 triệu):</h4><ul><li><strong>Mục ti\xeau:</strong> Chinh phục game AAA ở độ ph\xe2n giải Full HD (1080p) với thiết lập đồ họa cao nhất (Ultra Settings), hoặc 2K (1440p) với thiết lập cao, duy tr\xec FPS ổn định tr\xean 60, tận hưởng c\xf4ng nghệ Ray Tracing cho h\xecnh ảnh ch\xe2n thực.</li><li><strong>Cấu h\xecnh gợi \xfd:</strong></li></ul><figure class="table"><table><tbody><tr><td><p style="margin-left:0cm;text-align:center;"><strong>Linh kiện</strong></p></td><td><p style="margin-left:0cm;text-align:center;"><strong>Option 1</strong></p></td><td><p style="margin-left:0cm;text-align:center;"><strong>Option 2</strong></p></td><td><p style="margin-left:0cm;text-align:center;"><strong>Option 3</strong></p></td></tr><tr><td><strong>CPU</strong></td><td>Intel Core i5-13400F</td><td>AMD Ryzen 5 7600</td><td>Intel Core i5-12600KF</td></tr><tr><td><strong>Mainboard</strong></td><td>Chipset Intel B760, DDR4</td><td>Chipset AMD B650, DDR5</td><td>Chipset Intel B660, DDR4</td></tr><tr><td><strong>RAM</strong></td><td>16GB (2x8GB) DDR4 3600MHz</td><td>16GB (2x8GB) DDR5 5600MHz</td><td>16GB (2x8GB) DDR4 3600MHz</td></tr><tr><td><strong>VGA</strong></td><td>NVIDIA GeForce RTX 4060 Ti 8GB</td><td>AMD Radeon RX 7700 XT 12GB</td><td>NVIDIA GeForce RTX 3070 8GB (Cũ)</td></tr><tr><td><strong>SSD</strong></td><td>1TB NVMe PCIe 4.0</td><td>1TB NVMe PCIe 4.0</td><td>1TB NVMe PCIe 4.0</td></tr><tr><td><strong>Nguồn</strong></td><td>750W 80+ Gold</td><td>750W 80+ Gold</td><td>750W 80+ Gold</td></tr><tr><td><strong>Vỏ Case</strong></td><td>Mid-tower, hỗ trợ mainboard ATX/Micro-ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td><td>Mid-tower, hỗ trợ mainboard ATX/Micro-ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td><td>Mid-tower, hỗ trợ mainboard ATX/Micro-ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td></tr><tr><td><strong>Tản nhiệt</strong></td><td>Tản nhiệt kh\xed tầm trung, hỗ trợ socket CPU</td><td>Tản nhiệt kh\xed tầm trung, hỗ trợ socket CPU</td><td>Tản nhiệt kh\xed tầm trung, hỗ trợ socket CPU</td></tr></tbody></table></figure><h4 style="margin-left:0cm;">Ph\xe2n kh\xfac cao cấp (26-30 triệu):</h4><ul><li><strong>Mục ti\xeau:</strong> Trải nghiệm mượt m\xe0 game AAA ở độ ph\xe2n giải 2K (1440p) với thiết lập đồ họa cao đến Ultra, FPS ổn định 60-100+, hoặc Full HD max settings với FPS cao, bật Ray Tracing thoải m\xe1i.</li><li><strong>Cấu h\xecnh gợi \xfd:</strong></li></ul><figure class="table"><table><tbody><tr><td><strong>Linh kiện</strong></td><td><strong>Option 1</strong></td><td><strong>Option 2</strong></td><td><strong>Option 3</strong></td></tr><tr><td><strong>CPU</strong></td><td>Intel Core i5-13600KF</td><td>AMD Ryzen 7 5700X3D</td><td>Intel Core i5-14600KF</td></tr><tr><td><strong>Mainboard</strong></td><td>Chipset Intel Z790, DDR4</td><td>Chipset AMD B550</td><td>Chipset Intel Z790, DDR5</td></tr><tr><td><strong>RAM</strong></td><td>32GB (2x16GB) DDR4 3600MHz</td><td>32GB (2x16GB) DDR4 3600MHz</td><td>32GB (2x16GB) DDR5 6000MHz</td></tr><tr><td><strong>VGA</strong></td><td>NVIDIA GeForce RTX 4070 12GB</td><td>AMD Radeon RX 7800 XT 16GB</td><td>NVIDIA GeForce RTX 3080 10GB (Cũ)</td></tr><tr><td><strong>SSD</strong></td><td>1TB NVMe PCIe 4.0</td><td>1TB NVMe PCIe 4.0</td><td>1TB NVMe PCIe 4.0</td></tr><tr><td><strong>Nguồn</strong></td><td>850W 80+ Gold</td><td>850W 80+ Gold</td><td>850W 80+ Gold</td></tr><tr><td><strong>Vỏ Case</strong></td><td>Mid-tower hoặc Full-tower, hỗ trợ mainboard ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td><td>Mid-tower hoặc Full-tower, hỗ trợ mainboard ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td><td>Mid-tower hoặc Full-tower, hỗ trợ mainboard ATX, tho\xe1ng kh\xed, hỗ trợ tản nhiệt tốt</td></tr><tr><td><strong>Tản nhiệt</strong></td><td>Tản nhiệt kh\xed cao cấp hoặc AIO 240mm - 280mm, hỗ trợ socket CPU</td><td>Tản nhiệt kh\xed cao cấp hoặc AIO 240mm - 280mm, hỗ trợ socket CPU</td><td>Tản nhiệt kh\xed cao cấp hoặc AIO 240mm - 280mm, hỗ trợ socket CPU</td></tr></tbody></table></figure><h4 style="margin-left:0cm;">Ph\xe2n kh\xfac cao cấp (30-40 triệu):</h4><ul><li><strong>Mục ti\xeau:</strong> Max setting hầu hết c\xe1c tựa game AAA ở độ ph\xe2n giải 2K (1440p) với FPS cao 100+, hoặc trải nghiệm 4K (2160p) ổn định ở mức thiết lập cao,</li></ul><h3 style="margin-left:0cm;">Build PC văn ph\xf2ng l\xe0m việc/đa năng - Hiệu năng đa nhiệm, ổn định</h3><ul><li><strong>Mục ti\xeau:</strong> Đối với PC văn ph\xf2ng l\xe0m việc, CPU nhiều nh\xe2n, nhiều luồng l\xe0 yếu tố quan trọng để xử l\xfd đa nhiệm mượt m\xe0. RAM dung lượng lớn cũng cần thiết cho c\xe1c t\xe1c vụ nặng như chỉnh sửa video, thiết kế đồ họa.</li></ul><p><strong>Lựa chọn linh kiện:</strong></p><ul><li><strong>CPU:</strong> Intel Core i7, i9 hoặc AMD Ryzen 7, Ryzen 9 với nhiều nh\xe2n, nhiều luồng l\xe0 lựa chọn l\xfd tưởng cho PC l\xe0m việc.</li><li><strong>RAM:</strong> Tối thiểu 16GB RAM, n\xean n\xe2ng cấp l\xean 32GB hoặc 64GB nếu bạn thường xuy\xean l\xe0m việc với c\xe1c phần mềm nặng.</li><li><strong>VGA:</strong> T\xf9y thuộc v\xe0o nhu cầu c\xf4ng việc, bạn c\xf3 thể lựa chọn VGA ph\xf9 hợp. Nếu c\xf4ng việc của bạn li\xean quan đến đồ họa hoặc AI, RTX 3060 12GB l\xe0 lựa chọn đ\xe1ng c\xe2n nhắc.</li><li><strong>SSD:</strong> SSD NVMe tốc độ cao sẽ gi\xfap tăng tốc độ khởi động hệ điều h\xe0nh, load ứng dụng v\xe0 xử l\xfd dữ liệu.</li><li><strong>Mục ti\xeau:</strong> Cấu h\xecnh n\xe0y đảm bảo hiệu năng đa nhiệm mượt m\xe0, xử l\xfd nhanh ch\xf3ng c\xe1c t\xe1c vụ nặng, ph\xf9 hợp cho c\xe1c c\xf4ng việc văn ph\xf2ng, đồ họa, lập tr\xecnh, dựng phim…</li></ul><h2 style="margin-left:0cm;"><strong>Phong Vũ: Đồng H\xe0nh C\xf9ng Bạn Build PC Chuy\xean Nghiệp, Gi\xe1 Tốt Nhất!</strong></h2><figure class="image"><img src="https://storage.googleapis.com/staging.teko-gae.appspot.com/media/image/2025/1/17/ce58c47b-dea7-4744-8f12-bcc31d90b18e/image.jpeg" alt="Phong Vũ: Đồng H\xe0nh C\xf9ng Bạn Build PC Chuy\xean Nghiệp, Gi\xe1 Tốt Nhất!"><figcaption><i>Tự tin trải nghiệm - thoả ước mơ khi build PC tại Phong Vũ</i></figcaption></figure><p>Mệt mỏi v\xec những lựa chọn PC lắp sẵn kh\xf4ng ưng \xfd? Muốn tự tay x\xe2y dựng cấu h\xecnh c\xe2n mọi tựa game, đ\xe1p ứng mọi t\xe1c vụ? Dịch vụ build PC chuy\xean nghiệp tại Phong Vũ ch\xednh l\xe0 giải ph\xe1p d\xe0nh cho bạn! Ch\xfang t\xf4i cung cấp:</p><ul><li><strong>Tư vấn tận t\xe2m:</strong> Đội ngũ chuy\xean gia của Phong Vũ sẽ lắng nghe nhu cầu, tư vấn cấu h\xecnh tối ưu, ph\xf9 hợp với ng\xe2n s\xe1ch v\xe0 mục đ\xedch sử dụng của bạn.</li><li><strong>Linh kiện ch\xednh h\xe3ng:</strong> Cam kết sử dụng linh kiện ch\xednh h\xe3ng 100% từ c\xe1c thương hiệu uy t\xedn, bảo h\xe0nh đầy đủ.</li><li><strong>Lắp r\xe1p chuy\xean nghiệp:</strong> Kỹ thuật vi\xean tay nghề cao, đảm bảo lắp r\xe1p nhanh ch\xf3ng, ch\xednh x\xe1c, thẩm mỹ.</li></ul>';

// EXTERNAL MODULE: ./constants/buildpc.ts
var buildpc = __webpack_require__(360339);
;// CONCATENATED MODULE: ./containers/BuildPc/BuildPcDesktop.tsx
function BuildPcDesktop_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BuildPcDesktop_templateObject() {
    const data = BuildPcDesktop_taggedTemplateLiteral([
        "\n  height: 1rem;\n"
    ]);
    BuildPcDesktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BuildPcDesktop_templateObject1() {
    const data = BuildPcDesktop_taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n"
    ]);
    BuildPcDesktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BuildPcDesktop_templateObject2() {
    const data = BuildPcDesktop_taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 80px;\n  margin-bottom: 1rem;\n"
    ]);
    BuildPcDesktop_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BuildPcDesktop_templateObject3() {
    const data = BuildPcDesktop_taggedTemplateLiteral([
        "\n  @media print {\n    display: none;\n  }\n"
    ]);
    BuildPcDesktop_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = BuildPcDesktop_taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = BuildPcDesktop_taggedTemplateLiteral([
        "\n  margin: 0;\n  font-size: 1.5rem;\n  line-height: 2rem;\n  font-weight: 700;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = BuildPcDesktop_taggedTemplateLiteral([
        "\n  background-color: white;\n  margin-bottom: 1rem;\n  border-radius: 8px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
















const Spacer = emotion_styled_browser_esm["default"].div(BuildPcDesktop_templateObject());
const BuildPcDesktop_StyledBuildPcItem = (0,emotion_styled_browser_esm["default"])(BuildPcItem_es/* BuildPcItem */.y)(BuildPcDesktop_templateObject1());
const StyledBuildPcSummary = emotion_styled_browser_esm["default"].div(BuildPcDesktop_templateObject2());
const StyledContainer = (0,emotion_styled_browser_esm["default"])(Container_Container_es/* Container */.W)(BuildPcDesktop_templateObject3());
const StyledMiniSlides = (0,emotion_styled_browser_esm["default"])(MiniSlides_es/* MiniSlides */.H)(_templateObject4());
const PageTitle = emotion_styled_browser_esm["default"].h1(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.textPrimary;
});
const StyledDescription = (0,emotion_styled_browser_esm["default"])(Description_es/* Description */.d)(_templateObject6());
const BuildPcDesktop = ()=>{
    const { convertNewProductCard  } = useNewProductCard({
        disableHandlerUnder18: true
    });
    const { onAddMultipleItems , loading: cartLoading  } = (0,CartContextV2/* useCartV2 */.T6)();
    const router = (0,next_router.useRouter)();
    const { 0: category , 1: setCategory  } = (0,react.useState)(null);
    const dispatch = (0,BuildPcContext/* useBuildPcDispatch */.bC)();
    const state = (0,BuildPcContext/* useBuildPcState */.Gh)();
    const { 0: allSkus , 1: setAllSkus  } = (0,react.useState)([]);
    const { banners: topSlider , loading: loadingTopSlider  } = (0,banners/* useBanners */.U)("pv-buildpc-slider-banner");
    const { banners: staticBanners  } = (0,banners/* useBanners */.U)("pv-buildpc-static-banner");
    const buildPcLocalVariable = "buildPc2";
    const getLocalConfigs = ()=>{
        let result = [
            {},
            {},
            {}
        ];
        const lsBuildPcLocalConfigs =  true ? localStorage.getItem(buildPcLocalVariable) : 0;
        if (!!lsBuildPcLocalConfigs && (0,string_es/* parseJsonStringSafely */.O)(lsBuildPcLocalConfigs).length > 0) {
            result = (0,string_es/* parseJsonStringSafely */.O)(lsBuildPcLocalConfigs);
        }
        return result;
    };
    const getAllConfigSkus = (configurations)=>{
        const skus = [];
        configurations.forEach((config)=>{
            var ref;
            (ref = Object.keys(config)) === null || ref === void 0 ? void 0 : ref.forEach((key)=>{
                var ref, ref1;
                if (!skus.includes((ref = config[key].product) === null || ref === void 0 ? void 0 : ref.sku)) skus.push((ref1 = config[key].product) === null || ref1 === void 0 ? void 0 : ref1.sku);
            });
        });
        return skus;
    };
    const { result , isLoading  } = (0,useDiscovery/* useSkus */.TA)(allSkus.length ? allSkus : []);
    const convertedProductsData = (0,react.useMemo)(()=>{
        return result === null || result === void 0 ? void 0 : result.products.map(convertNewProductCard);
    }, [
        result
    ]);
    const changeConfiguration = (index)=>{
        dispatch({
            type: "CHANGE_CONFIGURATION",
            payload: index
        });
    };
    const onAddConfigurationToCart = async ()=>{
        try {
            const configKeys = Object.keys(state.currentConfiguration);
            const products = [];
            for(let i = 0; i < configKeys.length; i += 1){
                const key = configKeys[i];
                const product = convertedProductsData.find((el)=>el.sku === state.currentConfiguration[key].product.sku);
                const quantity = state.currentConfiguration[key].quantity;
                if (product) products.push({
                    sku: product.sku,
                    quantity,
                    promotionId: product.selectPromotionId
                });
            }
            await onAddMultipleItems(products);
        } catch (error) {
            dist_index_es/* logger.log */.k.log(error);
        }
    };
    (0,react.useEffect)(()=>{
        dispatch({
            type: "SET_CONFIGURATIONS",
            payload: getLocalConfigs()
        });
    }, []);
    (0,react.useEffect)(()=>{
        localStorage.setItem(buildPcLocalVariable, JSON.stringify(state.configurations));
        setAllSkus(getAllConfigSkus(state.configurations));
    }, [
        state.currentConfiguration
    ]);
    const isEmpty = (0,react.useMemo)(()=>{
        return Object.keys(state.currentConfiguration).length === 0;
    }, [
        state.currentConfiguration
    ]);
    const total = (0,react.useMemo)(()=>{
        if (isEmpty) return 0;
        return Object.keys(state.currentConfiguration).reduce((total, current)=>{
            var ref, ref1, ref2, ref3;
            const line = state.currentConfiguration[current];
            const price = (line === null || line === void 0 ? void 0 : (ref = line.product) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.latestPrice) || (line === null || line === void 0 ? void 0 : (ref2 = line.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.price) || 0;
            return total + price * line.quantity;
        }, 0);
    }, [
        state.currentConfiguration,
        isEmpty
    ]);
    const breadCrumbs = [
        {
            link: "/",
            name: (0,i18n.t)("Trang chủ")
        },
        {
            disabled: true,
            link: "#",
            name: "Build Pc"
        }, 
    ];
    // Specific flow for PV: https://jira.teko.vn/browse/UX4BUYER-6625
    const initialSocketOption = (0,react.useMemo)(()=>{
        const getInitialFilter = (target, current)=>{
            var ref;
            if ((category === null || category === void 0 ? void 0 : category.id) === target && ((ref = state.currentConfiguration[current]) === null || ref === void 0 ? void 0 : ref.quantity) > 0) {
                var ref1;
                const product = convertedProductsData.find((p)=>p.sku === state.currentConfiguration[current].product.sku);
                const socketOptionValue = product === null || product === void 0 ? void 0 : (ref1 = product.attributeGroups) === null || ref1 === void 0 ? void 0 : ref1.find((att)=>buildpc/* SOCKET_ATTRIBUTE_GROUPS_ID.includes */.AT.includes(att.id));
                if (!!socketOptionValue) {
                    switch(target){
                        case buildpc/* CPU_CATEGORY_ID */.rY:
                            var ref2;
                            return {
                                filterCode: buildpc/* CPU_SOCKET_ATTRIBUTE_CODE */.Bf,
                                filterName: socketOptionValue.name,
                                optionName: (ref2 = socketOptionValue.value) === null || ref2 === void 0 ? void 0 : ref2.trim()
                            };
                        case buildpc/* MAIN_BOARD_CATEGORY_ID */.Gp:
                            var ref3;
                            return {
                                filterCode: buildpc/* MAIN_BOARD_SOCKET_ATTRIBUTE_CODE */.t5,
                                filterName: socketOptionValue.name,
                                optionName: (ref3 = socketOptionValue.value) === null || ref3 === void 0 ? void 0 : ref3.trim()
                            };
                    }
                }
            }
            return null;
        };
        return getInitialFilter(buildpc/* CPU_CATEGORY_ID */.rY, buildpc/* MAIN_BOARD_CATEGORY_ID */.Gp) || getInitialFilter(buildpc/* MAIN_BOARD_CATEGORY_ID */.Gp, buildpc/* CPU_CATEGORY_ID */.rY) || {};
    }, [
        JSON.stringify(state.currentConfiguration),
        category
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {
                isLoading: isLoading || cartLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                            justify: "start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_es/* Breadcrumbs */.O, {
                                breadcrumbs: breadCrumbs
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMiniSlides, {
                            height: 200,
                            width: 1200,
                            isLoading: loadingTopSlider,
                            banners: topSlider || []
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle, {
                            children: "Build PC - X\xe2y dựng cấu h\xecnh m\xe1y t\xednh"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                            marginTop: "s16",
                            justify: "space-between",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                span: 8.5,
                                paddingLeft: "s8",
                                paddingRight: "s8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcTabs_es/* BuildPcTabs */.N, {
                                    onClickTab: (index)=>changeConfiguration(index)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            marginTop: "s16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    span: 8.5,
                                    paddingLeft: "s8",
                                    paddingRight: "s8",
                                    children: CategoryRepository.all().map((category)=>{
                                        const selectedHardware = state.currentConfiguration[category.id];
                                        let product = null;
                                        if (selectedHardware) {
                                            product = convertedProductsData.find((product)=>product.sku === selectedHardware.product.sku) || selectedHardware.product;
                                        }
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcDesktop_StyledBuildPcItem, {
                                            title: category.name,
                                            icon: category.icon,
                                            onIncrease: ()=>dispatch({
                                                    type: "ADD_HARDWARE",
                                                    payload: {
                                                        categoryId: category.id,
                                                        product: selectedHardware.product
                                                    }
                                                }),
                                            onDecrease: ()=>dispatch({
                                                    type: "REDUCE_HARDWARE_QUANTITY",
                                                    payload: {
                                                        categoryId: category.id
                                                    }
                                                }),
                                            setQuantity: (value)=>dispatch({
                                                    type: "SET_HARDWARE_QUANTITY",
                                                    payload: {
                                                        categoryId: category.id,
                                                        quantity: value
                                                    }
                                                }),
                                            product: product ? product : undefined,
                                            actionText: product ? (0,i18n.t)("Sửa") : (0,i18n.t)("Chọn"),
                                            onClick: ()=>setCategory(category),
                                            quantity: selectedHardware ? selectedHardware.quantity : undefined
                                        }, category.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    span: 3.5,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBuildPcSummary, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcSummary_es/* BuildPcSummary */.b, {
                                                total: total,
                                                selectedCount: Object.keys(state.currentConfiguration).length,
                                                onAddToCart: onAddConfigurationToCart,
                                                onBuy: ()=>{
                                                    onAddConfigurationToCart().then(()=>router.push("/cart"));
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card_es/* Card */.Z, {
                                                marginTop: "s16",
                                                padding: "s16",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                                                    targetType: "_blank",
                                                    targetPath: "https://www.messenger.com/t/phongvuvietnam",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                                        variant: "primary",
                                                        block: true,
                                                        children: (0,i18n.t)("Nhận tư vấn từ chuy\xean gia")
                                                    })
                                                })
                                            }),
                                            staticBanners && !!staticBanners[0] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                                                        targetPath: staticBanners[0].targetPath,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                                            hover: "zoom",
                                                            borderRadius: 8,
                                                            src: staticBanners[0].image
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        pageDescriptionContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_Container_es/* Container */.W, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescription, {
                                className: "ck-content",
                                content: pageDescriptionContent,
                                maxHeight: 760,
                                showMoreLabel: (0,i18n.t)("Xem th\xeam nội dung"),
                                showLessLabel: (0,i18n.t)("Thu gọn nội dung")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
                            width: "748px",
                            visible: !!category,
                            onClose: ()=>setCategory(null),
                            footer: false,
                            children: category && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcModal, {
                                onHide: ()=>setCategory(null),
                                category: category,
                                initialSocketOption: initialSocketOption
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintBuildPc_es/* PrintBuildPc */.r, {
                total: total,
                buildpc: state.currentConfiguration
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/NavBar/DetailNavBar.es.js
var DetailNavBar_es = __webpack_require__(432283);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/HomepageFilled.es.js
var HomepageFilled_es = __webpack_require__(848884);
// EXTERNAL MODULE: ./components/Layout/MobileLayout.tsx
var MobileLayout = __webpack_require__(303094);
// EXTERNAL MODULE: ./helpers/terra.ts
var terra = __webpack_require__(632843);
// EXTERNAL MODULE: ./containers/BuildPc/BuildPcMobileTabs.tsx
var BuildPcMobileTabs = __webpack_require__(704251);
;// CONCATENATED MODULE: ./containers/BuildPc/BuildPcMobile.tsx
function BuildPcMobile_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BuildPcMobile_templateObject() {
    const data = BuildPcMobile_taggedTemplateLiteral([
        "\n  height: 1rem;\n"
    ]);
    BuildPcMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BuildPcMobile_templateObject1() {
    const data = BuildPcMobile_taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n  width: 100%;\n"
    ]);
    BuildPcMobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BuildPcMobile_templateObject2() {
    const data = BuildPcMobile_taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n  width: 100%;\n"
    ]);
    BuildPcMobile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BuildPcMobile_templateObject3() {
    const data = BuildPcMobile_taggedTemplateLiteral([
        "\n  padding: 0;\n  @media print {\n    display: none;\n  }\n"
    ]);
    BuildPcMobile_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BuildPcMobile_templateObject4() {
    const data = BuildPcMobile_taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n"
    ]);
    BuildPcMobile_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BuildPcMobile_templateObject5() {
    const data = BuildPcMobile_taggedTemplateLiteral([
        "\n  height: 100%;\n  .teko-modal-content {\n    height: 100%;\n    border-radius: 0;\n    padding: 16px;\n  }\n  .teko-modal-body {\n    height: 100%;\n  }\n"
    ]);
    BuildPcMobile_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function BuildPcMobile_templateObject6() {
    const data = BuildPcMobile_taggedTemplateLiteral([
        "\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1rem;\n  font-weight: 700;\n  color: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    BuildPcMobile_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = BuildPcMobile_taggedTemplateLiteral([
        "\n  background-color: white;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





















const BuildPcMobile_Spacer = emotion_styled_browser_esm["default"].div(BuildPcMobile_templateObject());
const BuildPcMobile_StyledBuildPcItem = (0,emotion_styled_browser_esm["default"])(BuildPcMobileItem/* BuildPcMobileItem */.g)(BuildPcMobile_templateObject1());
const BuildPcMobile_StyledBuildPcSummary = emotion_styled_browser_esm["default"].div(BuildPcMobile_templateObject2());
const BuildPcMobile_StyledContainer = (0,emotion_styled_browser_esm["default"])(Container_Container_es/* Container */.W)(BuildPcMobile_templateObject3());
const BuildPcMobile_StyledMiniSlides = (0,emotion_styled_browser_esm["default"])(MiniSlides_es/* MiniSlides */.H)(BuildPcMobile_templateObject4());
const StyledModal = (0,emotion_styled_browser_esm["default"])(Modal_es/* Modal */.u)(BuildPcMobile_templateObject5());
const BuildPcMobile_PageTitle = emotion_styled_browser_esm["default"].h1(BuildPcMobile_templateObject6(), (param)=>{
    let { theme  } = param;
    return theme.colors.textPrimary;
});
const SiteDescription = (0,emotion_styled_browser_esm["default"])(Description_es/* Description */.d)(_templateObject7());
const BuildPcMobile = ()=>{
    const { convertNewProductCard  } = useNewProductCard({
        disableHandlerUnder18: true
    });
    const { onAddMultipleItems , loading: cartLoading  } = (0,CartContextV2/* useCartV2 */.T6)();
    const router = (0,next_router.useRouter)();
    const { 0: category , 1: setCategory  } = (0,react.useState)(null);
    const dispatch = (0,BuildPcContext/* useBuildPcDispatch */.bC)();
    const state = (0,BuildPcContext/* useBuildPcState */.Gh)();
    const { 0: allSkus , 1: setAllSkus  } = (0,react.useState)([]);
    const { banners: topSlider , loading: loadingTopSlider  } = (0,banners/* useBanners */.U)("pv-buildpc-slider-banner");
    const { banners: staticBanners  } = (0,banners/* useBanners */.U)("pv-buildpc-static-banner");
    const buildPcLocalVariable = "buildPc2";
    const getLocalConfigs = ()=>{
        let result = [
            {},
            {},
            {}
        ];
        const lsBuildPcLocalConfigs =  true ? localStorage.getItem(buildPcLocalVariable) : 0;
        if (!!lsBuildPcLocalConfigs && (0,string_es/* parseJsonStringSafely */.O)(lsBuildPcLocalConfigs).length > 0) {
            result = (0,string_es/* parseJsonStringSafely */.O)(lsBuildPcLocalConfigs);
        }
        return result;
    };
    const getAllConfigSkus = (configurations)=>{
        const skus = [];
        configurations.forEach((config)=>{
            var ref;
            (ref = Object.keys(config)) === null || ref === void 0 ? void 0 : ref.forEach((key)=>{
                var ref, ref1;
                if (!skus.includes((ref = config[key].product) === null || ref === void 0 ? void 0 : ref.sku)) skus.push((ref1 = config[key].product) === null || ref1 === void 0 ? void 0 : ref1.sku);
            });
        });
        return skus;
    };
    const { result , isLoading  } = (0,useDiscovery/* useSkus */.TA)(allSkus.length ? allSkus : []);
    const convertedProductsData = (0,react.useMemo)(()=>{
        return result === null || result === void 0 ? void 0 : result.products.map(convertNewProductCard);
    }, [
        result
    ]);
    const changeConfiguration = (index)=>{
        dispatch({
            type: "CHANGE_CONFIGURATION",
            payload: index
        });
    };
    const onAddConfigurationToCart = async ()=>{
        try {
            const configKeys = Object.keys(state.currentConfiguration);
            const products = [];
            for(let i = 0; i < configKeys.length; i += 1){
                const key = configKeys[i];
                const product = convertedProductsData.find((el)=>el.sku === state.currentConfiguration[key].product.sku);
                const quantity = state.currentConfiguration[key].quantity;
                if (product) products.push({
                    sku: product.sku,
                    quantity,
                    promotionId: product.selectPromotionId
                });
            }
            await onAddMultipleItems(products);
        } catch (error) {
            dist_index_es/* logger.log */.k.log(error);
        }
    };
    (0,react.useEffect)(()=>{
        dispatch({
            type: "SET_CONFIGURATIONS",
            payload: getLocalConfigs()
        });
    }, []);
    (0,react.useEffect)(()=>{
        localStorage.setItem(buildPcLocalVariable, JSON.stringify(state.configurations));
        setAllSkus(getAllConfigSkus(state.configurations));
    }, [
        state.currentConfiguration
    ]);
    const isEmpty = (0,react.useMemo)(()=>{
        return Object.keys(state.currentConfiguration).length === 0;
    }, [
        state.currentConfiguration
    ]);
    const total = (0,react.useMemo)(()=>{
        if (isEmpty) return 0;
        return Object.keys(state.currentConfiguration).reduce((total, current)=>{
            var ref, ref1, ref2, ref3;
            const line = state.currentConfiguration[current];
            const price = (line === null || line === void 0 ? void 0 : (ref = line.product) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.latestPrice) || (line === null || line === void 0 ? void 0 : (ref2 = line.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.price) || 0;
            return total + price * line.quantity;
        }, 0);
    }, [
        state.currentConfiguration,
        isEmpty
    ]);
    const breadCrumbs = [
        {
            link: "/",
            name: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageFilled_es/* HomepageFilled */.f, {
                size: 24,
                color: "placeholder"
            })
        },
        {
            disabled: true,
            link: "#",
            name: "Build PC"
        }, 
    ];
    // Specific flow for PV: https://jira.teko.vn/browse/UX4BUYER-6625
    // the same function with desktop ==> todo: refactor desktop and mobile, should move state to buildPcContext
    const initialSocketOption = (0,react.useMemo)(()=>{
        const getInitialFilter = (target, current)=>{
            var ref;
            if ((category === null || category === void 0 ? void 0 : category.id) === target && ((ref = state.currentConfiguration[current]) === null || ref === void 0 ? void 0 : ref.quantity) > 0) {
                var ref1;
                const product = convertedProductsData.find((p)=>p.sku === state.currentConfiguration[current].product.sku);
                const socketOptionValue = product === null || product === void 0 ? void 0 : (ref1 = product.attributeGroups) === null || ref1 === void 0 ? void 0 : ref1.find((att)=>buildpc/* SOCKET_ATTRIBUTE_GROUPS_ID.includes */.AT.includes(att.id));
                if (!!socketOptionValue) {
                    switch(target){
                        case buildpc/* CPU_CATEGORY_ID */.rY:
                            var ref2;
                            return {
                                filterCode: buildpc/* CPU_SOCKET_ATTRIBUTE_CODE */.Bf,
                                filterName: socketOptionValue.name,
                                optionName: (ref2 = socketOptionValue.value) === null || ref2 === void 0 ? void 0 : ref2.trim()
                            };
                        case buildpc/* MAIN_BOARD_CATEGORY_ID */.Gp:
                            var ref3;
                            return {
                                filterCode: buildpc/* MAIN_BOARD_SOCKET_ATTRIBUTE_CODE */.t5,
                                filterName: socketOptionValue.name,
                                optionName: (ref3 = socketOptionValue.value) === null || ref3 === void 0 ? void 0 : ref3.trim()
                            };
                    }
                }
            }
            return null;
        };
        return getInitialFilter(buildpc/* CPU_CATEGORY_ID */.rY, buildpc/* MAIN_BOARD_CATEGORY_ID */.Gp) || getInitialFilter(buildpc/* MAIN_BOARD_CATEGORY_ID */.Gp, buildpc/* CPU_CATEGORY_ID */.rY) || {};
    }, [
        JSON.stringify(state.currentConfiguration),
        category
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {
                isLoading: isLoading || cartLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuildPcMobile_StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLayout/* MobileLayout */.n, {
                            navbar: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailNavBar_es/* DetailNavBar */.W, {
                                goBack: ()=>{
                                    terra/* default.handleBackOr */.Z.handleBackOr(()=>{
                                        router.back();
                                    });
                                }
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    padding: "0 1rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                        justify: "start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_es/* Breadcrumbs */.O, {
                                            breadcrumbs: breadCrumbs,
                                            isMobile: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcMobile_StyledMiniSlides, {
                                        height: 200,
                                        width: 1200,
                                        isLoading: loadingTopSlider,
                                        banners: topSlider || []
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcMobile_PageTitle, {
                                        children: "Build PC - X\xe2y dựng cấu h\xecnh m\xe1y t\xednh"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                        marginTop: "s16",
                                        justify: "space-between",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcMobileTabs/* default */.Z, {
                                            onClickTab: (index)=>changeConfiguration(index)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                        marginTop: "s16",
                                        children: CategoryRepository.all().map((category)=>{
                                            const selectedHardware = state.currentConfiguration[category.id];
                                            let product = null;
                                            if (selectedHardware) {
                                                product = convertedProductsData.find((product)=>product.sku === selectedHardware.product.sku) || selectedHardware.product;
                                            }
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcMobile_StyledBuildPcItem, {
                                                title: category.name,
                                                icon: category.icon,
                                                onIncrease: ()=>dispatch({
                                                        type: "ADD_HARDWARE",
                                                        payload: {
                                                            categoryId: category.id,
                                                            product: selectedHardware.product
                                                        }
                                                    }),
                                                onDecrease: ()=>dispatch({
                                                        type: "REDUCE_HARDWARE_QUANTITY",
                                                        payload: {
                                                            categoryId: category.id
                                                        }
                                                    }),
                                                setQuantity: (value)=>dispatch({
                                                        type: "SET_HARDWARE_QUANTITY",
                                                        payload: {
                                                            categoryId: category.id,
                                                            quantity: value
                                                        }
                                                    }),
                                                product: product ? product : undefined,
                                                actionText: product ? (0,i18n.t)("Sửa") : (0,i18n.t)("Chọn"),
                                                onClick: ()=>setCategory(category),
                                                quantity: selectedHardware ? selectedHardware.quantity : undefined
                                            }, category.id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                        marginTop: "s8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuildPcMobile_StyledBuildPcSummary, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcSummary_es/* BuildPcSummary */.b, {
                                                    total: total,
                                                    selectedCount: Object.keys(state.currentConfiguration).length,
                                                    onAddToCart: onAddConfigurationToCart,
                                                    onBuy: ()=>{
                                                        onAddConfigurationToCart().then(()=>router.push("/cart"));
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card_es/* Card */.Z, {
                                                    marginTop: "s16",
                                                    padding: "s16",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                                            variant: "primary",
                                                            block: true,
                                                            onClick: ()=>window.print(),
                                                            marginBottom: "s16",
                                                            children: (0,i18n.t)("Tải file PDF cấu h\xecnh")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                                                            targetType: "_blank",
                                                            targetPath: "https://www.messenger.com/t/phongvuvietnam",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                                                variant: "primary",
                                                                block: true,
                                                                children: (0,i18n.t)("Nhận tư vấn từ chuy\xean gia")
                                                            })
                                                        })
                                                    ]
                                                }),
                                                staticBanners && !!staticBanners[0] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcMobile_Spacer, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                                                            targetPath: "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                                                hover: "zoom",
                                                                borderRadius: 8,
                                                                src: staticBanners[0].image
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    pageDescriptionContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteDescription, {
                                            className: "ck-content",
                                            content: pageDescriptionContent,
                                            maxHeight: 445,
                                            showMoreLabel: (0,i18n.t)("Xem th\xeam nội dung"),
                                            showLessLabel: (0,i18n.t)("Thu gọn nội dung")
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModal, {
                            width: "748px",
                            maxWidth: "100%",
                            visible: !!category,
                            onClose: ()=>setCategory(null),
                            footer: false,
                            children: category && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcModal, {
                                onHide: ()=>setCategory(null),
                                category: category,
                                initialSocketOption: initialSocketOption
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintBuildPc_es/* PrintBuildPc */.r, {
                total: total,
                buildpc: state.currentConfiguration
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/HeadSection.tsx
var HeadSection = __webpack_require__(665207);
;// CONCATENATED MODULE: ./containers/BuildPc/index.tsx
function BuildPc_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BuildPc_templateObject() {
    const data = BuildPc_taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n"
    ]);
    BuildPc_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







const BuildPc_StyledContainer = (0,styled_es/* styled */.z)(Container_es/* Container */.W)(BuildPc_templateObject());
const BuildPc = ()=>{
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadSection/* HeadSection */.I, {
                title: "Build PC - X\xe2y dựng cấu h\xecnh m\xe1y t\xednh",
                metaTitle: "Build PC gaming, văn ph\xf2ng - X\xe2y dựng cấu h\xecnh PC gi\xe1 tốt",
                description: "Dịch vụ build PC x\xe2y dựng cấu h\xecnh m\xe1y chuẩn. Cấu h\xecnh gaming, đồ họa, văn ph\xf2ng tối ưu, linh kiện ch\xednh h\xe3ng, gi\xe1 tốt. Li\xean hệ ngay để được tư vấn!"
            }),
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPc_StyledContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcDesktop, {})
            })
        ]
    });
};


/***/ }),

/***/ 677111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gh": function() { return /* binding */ useBuildPcState; },
/* harmony export */   "bC": function() { return /* binding */ useBuildPcDispatch; },
/* harmony export */   "sf": function() { return /* binding */ BuildPcProvider; }
/* harmony export */ });
/* unused harmony export buildPcReducer */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};


const initialState = {
    configurations: [
        {},
        {},
        {}
    ],
    currentConfigurationIndex: 0
};
function buildPcReducer(state, action) {
    switch(action.type){
        case "NEW_CONFIGURATION":
            return _objectSpreadProps(_objectSpread({}, state), {
                configurations: [
                    ...state.configurations,
                    {}
                ],
                currentConfigurationIndex: state.configurations.length
            });
        case "CHANGE_CONFIGURATION":
            return _objectSpreadProps(_objectSpread({}, state), {
                currentConfigurationIndex: action.payload
            });
        case "SET_CONFIGURATIONS":
            return _objectSpreadProps(_objectSpread({}, state), {
                configurations: action.payload
            });
        case "ADD_HARDWARE":
            return _objectSpreadProps(_objectSpread({}, state), {
                configurations: state.configurations.map((configuration, index)=>{
                    if (state.currentConfigurationIndex !== index) {
                        return configuration;
                    }
                    let quantity = 0;
                    if (!configuration[action.payload.categoryId]) {
                        quantity = 1;
                    }
                    if (configuration[action.payload.categoryId]) {
                        quantity = configuration[action.payload.categoryId].product.sku === action.payload.product.sku ? configuration[action.payload.categoryId].quantity + 1 : 1;
                    }
                    return _objectSpreadProps(_objectSpread({}, configuration), {
                        [action.payload.categoryId]: {
                            product: action.payload.product,
                            quantity
                        }
                    });
                })
            });
        case "SET_HARDWARE_QUANTITY":
            return _objectSpreadProps(_objectSpread({}, state), {
                configurations: state.configurations.map((configuration, index)=>{
                    if (state.currentConfigurationIndex !== index) {
                        return configuration;
                    }
                    let quantity = action.payload.quantity;
                    if (quantity > 99) quantity = 99;
                    if (quantity < 1 || !configuration[action.payload.categoryId]) quantity = 1;
                    return _objectSpreadProps(_objectSpread({}, configuration), {
                        [action.payload.categoryId]: _objectSpreadProps(_objectSpread({}, configuration[action.payload.categoryId]), {
                            quantity
                        })
                    });
                })
            });
        case "REDUCE_HARDWARE_QUANTITY":
            return _objectSpreadProps(_objectSpread({}, state), {
                configurations: state.configurations.map((configuration, index)=>{
                    if (state.currentConfigurationIndex !== index || !configuration[action.payload.categoryId]) {
                        return configuration;
                    }
                    if (configuration[action.payload.categoryId].quantity === 1) {
                        const _categoryId = action.payload.categoryId, { [_categoryId]: omit  } = configuration, remaindingConfiguration = _objectWithoutProperties(configuration, [
                            _categoryId
                        ].map(_toPropertyKey));
                        return remaindingConfiguration;
                    }
                    return _objectSpreadProps(_objectSpread({}, configuration), {
                        [action.payload.categoryId]: _objectSpreadProps(_objectSpread({}, configuration[action.payload.categoryId]), {
                            quantity: configuration[action.payload.categoryId].quantity - 1
                        })
                    });
                })
            });
        case "REMOVE_HARDWARE":
            return _objectSpreadProps(_objectSpread({}, state), {
                configurations: state.configurations.map((configuration, index)=>{
                    if (state.currentConfigurationIndex !== index) {
                        return configuration;
                    }
                    const _categoryId = action.payload.categoryId, { [_categoryId]: omit  } = configuration, remaindingConfiguration = _objectWithoutProperties(configuration, [
                        _categoryId
                    ].map(_toPropertyKey));
                    return _objectSpread({}, remaindingConfiguration);
                })
            });
        default:
            return state;
    }
}
const BuildPcStateContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(initialState);
const BuildPcDispatchContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
const BuildPcProvider = (param)=>{
    let { children  } = param;
    const { 0: state , 1: dispatch  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(buildPcReducer, initialState);
    const computedState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return _objectSpreadProps(_objectSpread({}, state), {
            currentConfiguration: state.configurations[state.currentConfigurationIndex] || {}
        });
    }, [
        state
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BuildPcStateContext.Provider, {
        value: computedState,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BuildPcDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
function useBuildPcState() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(BuildPcStateContext);
    if (!context) {
        throw new Error("useBuildPcState must be inside a BuildPcProvider with a state value");
    }
    return context;
}
function useBuildPcDispatch() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(BuildPcDispatchContext);
    if (!context) {
        throw new Error("useBuildPcDispatch must be inside a BuildPcProvider with a state value");
    }
    return context;
}


/***/ }),

/***/ 101763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ buildTreeCategories; },
/* harmony export */   "q": function() { return /* binding */ convertMegaMenuItem; }
/* harmony export */ });
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(875663);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(788813);
/* harmony import */ var _teko_slug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93512);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const convertUrl = (targetPath, urlType, isTargetBlank)=>{
    if (!targetPath) {
        return undefined;
    }
    if (urlType === "rewrite") {
        return {
            href: "/search?router=productListing&" + targetPath,
            target: isTargetBlank ? "_blank" : "_self"
        };
    }
    return {
        href: targetPath,
        target: isTargetBlank ? "_blank" : "_self"
    };
};
const getMenuItemUrl = (item)=>{
    const { isTargetBlank , url , targetPath , urlType  } = item || {};
    const target = isTargetBlank ? "_blank" : "_self";
    const href = url || (urlType === "rewrite" ? "/search?router=productListing&" + targetPath : targetPath);
    return {
        href,
        target
    };
};
const getUrl = (item)=>{
    const { isTargetBlank , url  } = item || {};
    const target = isTargetBlank ? "_blank" : "_self";
    if (!url) return null;
    return {
        href: url,
        target
    };
};
const convertUrlParamsToObject = (urlParams)=>{
    const urlParamsArray = Array.from(urlParams);
    return urlParamsArray.reduce((acc, cur)=>_objectSpreadProps(_objectSpread({}, acc), {
            [cur[0]]: cur[1]
        }), {});
};
const computeBlockPageUrl = (menu)=>{
    var ref;
    if (!menu.targetPath || menu.urlType !== "rewrite") {
        return null;
    }
    const menuConfig = menu.configs;
    const targetFilterParams = convertUrlParamsToObject(new URLSearchParams(menu.targetPath));
    // targetPath has only 1 filter config
    if (((ref = Object.keys(targetFilterParams)) === null || ref === void 0 ? void 0 : ref.length) === 1) {
        var ref1;
        const filterKey = Object.keys(targetFilterParams)[0];
        const filterValue = ((ref1 = menuConfig[filterKey]) === null || ref1 === void 0 ? void 0 : ref1.length) === 1 ? menuConfig[filterKey][0] : null;
        if (!filterValue) {
            return null;
        }
        switch(filterKey){
            case "brands":
                return {
                    href: {
                        pathname: "/brands/[brandId]",
                        query: {
                            brandId: filterValue
                        }
                    },
                    target: menu.isTargetBlank ? "_blank" : "_self",
                    as: {
                        pathname: (0,___WEBPACK_IMPORTED_MODULE_0__/* .buildSlugUrl */ .hH)(_teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.BRAND */ .DZ.BRAND, menu.name, filterValue)
                    },
                    shallow: true
                };
            case "masterCategoryIds":
                return {
                    href: {
                        pathname: "/block-categories/[categoryId]",
                        query: {
                            categoryId: filterValue
                        }
                    },
                    target: menu.isTargetBlank ? "_blank" : "_self",
                    as: (0,___WEBPACK_IMPORTED_MODULE_0__/* .buildSlugUrl */ .hH)(_teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.CATEGORY */ .DZ.CATEGORY, menu.name, filterValue) || undefined,
                    shallow: true
                };
            case "sellerIds":
                return {
                    href: {
                        pathname: "/sellers/[sellerId]",
                        query: {
                            sellerId: filterValue
                        }
                    },
                    target: menu.isTargetBlank ? "_blank" : "_self",
                    as: (0,___WEBPACK_IMPORTED_MODULE_0__/* .buildSlugUrl */ .hH)(_teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.SELLER */ .DZ.SELLER, menu.name, filterValue) || undefined,
                    shallow: true
                };
            case "categories":
                return {
                    href: {
                        pathname: "/seller-categories/[sellerCategoryId]",
                        query: {
                            sellerCategoryId: filterValue
                        }
                    },
                    target: menu.isTargetBlank ? "_blank" : "_self",
                    as: "/".concat((0,_teko_slug__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(menu.name), "-scat.").concat(filterValue),
                    shallow: true
                };
            default:
                return null;
        }
    }
    return null;
};
const convertMegaMenuItem = (item)=>{
    var ref, ref1, ref2, ref3, ref4;
    return {
        id: item.id,
        name: item.name,
        icon: item.icon,
        link: getUrl(item) || computeBlockPageUrl(item) || getMenuItemUrl(item),
        banner: !!((ref = item.banners) === null || ref === void 0 ? void 0 : ref.length) ? {
            src: (ref1 = item.banners[0]) === null || ref1 === void 0 ? void 0 : ref1.image,
            hoverEffect: "zoom",
            link: convertUrl((ref2 = item.banners[0]) === null || ref2 === void 0 ? void 0 : ref2.targetPath, (ref3 = item.banners[0]) === null || ref3 === void 0 ? void 0 : ref3.urlType)
        } : undefined,
        children: ((ref4 = item.children) === null || ref4 === void 0 ? void 0 : ref4.map(convertMegaMenuItem)) || []
    };
};
const getValidBanners = (banners)=>{
    return banners.filter((banner)=>{
        if (!banner.isActive) return false;
        const currentTime = new Date().getTime();
        if (banner === null || banner === void 0 ? void 0 : banner.startDate) {
            if (!(banner === null || banner === void 0 ? void 0 : banner.endDate)) {
                return currentTime >= banner.startDate * 1000;
            }
            return banner.startDate * 1000 <= currentTime && banner.endDate * 1000 >= currentTime;
        }
        if (banner === null || banner === void 0 ? void 0 : banner.endDate) {
            return currentTime <= banner.endDate * 1000;
        }
        return true;
    });
};
const buildTreeCategories = (menuItems)=>{
    const rootMenuItems = menuItems.filter((param)=>{
        let { parentId  } = param;
        return !parentId;
    });
    const buildMenuItem = (root)=>{
        const children = menuItems.filter((param)=>{
            let { parentId  } = param;
            return parentId === root.id;
        });
        return _objectSpreadProps(_objectSpread({}, root), {
            banners: getValidBanners(root.banners || []),
            children: children.map(buildMenuItem)
        });
    };
    return rootMenuItems.map((root)=>buildMenuItem(root));
};


/***/ }),

/***/ 632843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68706);
/* harmony import */ var _terra_js_web_bridge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(685172);


const ShopFrontKitLoadable = __webpack_require__.e(/* import() */ 22765).then(__webpack_require__.t.bind(__webpack_require__, 722765, 23));
const PaymentKitLoadable = __webpack_require__.e(/* import() */ 25098).then(__webpack_require__.bind(__webpack_require__, 225098));
const waitForPaymentStatus = "WAITING_FOR_PAYMENT_CONFIRMATION";
const terraHelper = {
    isAvailable: _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable,
    getLoyaltyConfig: ()=>{
        return _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].loyalty */ .Z.loyalty().getLoyaltyConfig();
    },
    handleBackOr: async (callback)=>{
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
            const ShopFrontKit = (await ShopFrontKitLoadable).default;
            const shouldHandleBack = await ShopFrontKit.shouldHandleBack();
            if (shouldHandleBack) {
                ShopFrontKit.handleBack();
            } else {
                callback === null || callback === void 0 ? void 0 : callback();
            }
        } else {
            callback === null || callback === void 0 ? void 0 : callback();
        }
    },
    getScreenConfig: async ()=>{
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
            const ShopFrontKit = (await ShopFrontKitLoadable).default;
            return ShopFrontKit.getScreenConfig();
        } else {
            return Promise.resolve(undefined);
        }
    },
    finish: ()=>_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].finish */ .Z.finish(),
    payForOrder: (param)=>{
        let { order , customerProfileId , orderService  } = param;
        return terraHelper.pay({
            orderCode: order.code,
            orderId: order.id,
            amount: order.remainPayment,
            customerProfileId,
            orderService
        });
    },
    pay: async (param)=>{
        let { orderCode , orderId , amount , customerProfileId , orderService  } = param;
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
            const { default: PaymentKit , PaymentRequestBuilder  } = await PaymentKitLoadable;
            const paymentRequestBuilder = new PaymentRequestBuilder();
            const { MainMethodType  } = await __webpack_require__.e(/* import() */ 91621).then(__webpack_require__.bind(__webpack_require__, 891621));
            paymentRequestBuilder.setOrder({
                orderCode: orderCode,
                orderAmount: amount
            }).setPaymentMethods({
                mainMethod: {
                    method: MainMethodType.All,
                    amount
                },
                totalAmount: amount
            }).setOptions({
                shouldShowPaymentResultScreen: true
            });
            return PaymentKit.payForOrder(paymentRequestBuilder.build()).then((result)=>{
                switch(result.resultCode){
                    case "succeeded":
                        window.location.href = "/account/orders/".concat(orderId);
                        break;
                    case "canceled":
                    case "failed":
                        orderService.getOrder({
                            orderId,
                            customerId: customerProfileId
                        }).then((order)=>{
                            if (order.status === waitForPaymentStatus) {
                                window.location.href = "/confirm-payment/".concat(orderId);
                            } else {
                                window.location.href = "/account/orders?tab=WAIT_PAYMENT";
                            }
                        }).catch(()=>{
                            // this is a fallback in case the order is not synced with cov
                            window.location.href = "/account/orders?tab=WAIT_PAYMENT";
                        });
                        break;
                }
            });
        }
        return Promise.resolve();
    },
    observeOpenBuyNow: (params, handlers)=>{
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
            _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].common */ .Z.common().openBuyNow(params).subscribe(handlers);
        }
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (terraHelper);


/***/ }),

/***/ 702070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JR": function() { return /* binding */ useMenuItems; },
/* harmony export */   "p6": function() { return /* binding */ useMenuItemById; }
/* harmony export */ });
/* unused harmony export getMenuItems */
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(859676);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(101763);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(643015);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(420577);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




// TODO: temporary function, to avoid having to copy it
// will clean it up later.
// ideally move inside discovery method .getMenuItems
const getMenuItems = async (discoveryService, zone)=>{
    try {
        var ref, ref1;
        const data = await discoveryService.getMenuItems(zone);
        return {
            menuItems: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.menuItems) || [],
            parents: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .buildTreeCategories */ .Q)((data === null || data === void 0 ? void 0 : (ref1 = data.result) === null || ref1 === void 0 ? void 0 : ref1.menuItems) || [])
        };
    } catch (er) {
        _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(er);
        return {
            menuItems: [],
            parents: []
        };
    }
};
const useMenuItems = function(zone) {
    let defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        menuItems: [],
        parents: []
    };
    const { discoveryService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useServices */ .Su)();
    const { data , error , isValidating  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)([
        "/menu-items",
        zone
    ], async (_, zone)=>await getMenuItems(discoveryService, zone), {
        fallbackData: _objectSpread({}, defaultValue),
        onError: (e)=>{
            _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error("getMenuItems error:", e);
            return defaultValue;
        }
    });
    return {
        result: data || {
            menuItems: [],
            parents: []
        },
        isLoading: !zone ? false : !error && !data || isValidating,
        isError: error
    };
};
const useMenuItemById = (categoryId)=>{
    const { discoveryService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useServices */ .Su)();
    const url = "/menu-item/".concat(categoryId);
    const { data , error  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(categoryId ? url : null, async ()=>{
        return await discoveryService.getMenuItemById(categoryId);
    });
    return {
        result: data === null || data === void 0 ? void 0 : data.result,
        isLoading: !categoryId ? false : !error && !data,
        isError: error
    };
};


/***/ })

}]);